<template>
  <div class="div-odontogram">
    <b-row class="mb-5">
      <b-col cols="12">
        <label class="text-title m-0">Pemeriksaan Extraoral</label>
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Muka</label>
        <br>
        <vue-select
          :options="['Simetris', 'Asimetris']"
          v-model="formOdontogram.muka"
          class="custom_select"
          id="muka"
          @input="
            setValue({
              label: 'muka',
              $event,
            })
          "
        />
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Warna Kulit</label>
        <br>
        <vue-select
          :options="['Normal', 'Pucat', 'Kebiruan']"
          v-model="formOdontogram.warna_kulit"
          class="custom_select"
          id="warna_kulit"
          @input="
            setValue({
              label: 'warna_kulit',
              $event,
            })
          "
        />
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Bengkak</label>
        <br>
        <vue-select
          :options="['Ada', 'Tidak Ada']"
          v-model="formOdontogram.bengkak"
          class="custom_select"
          id="bengkak"
          @input="
            setValue({
              label: 'bengkak',
              $event,
            })
          "
        />
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Suhu Kulit</label>
        <br>
        <vue-select
          :options="['Normal', 'Hipertermi', 'Hipotermi']"
          v-model="formOdontogram.suhu_kulit"
          class="custom_select"
          id="suhu_kulit"
          @input="
            setValue({
              label: 'suhu_kulit',
              $event,
            })
          "
        />
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Konsistensi</label>
        <br>
        <vue-select
          :options="['Tak Teraba', 'Keras', 'Lunak', 'Sakit']"
          v-model="formOdontogram.konsistensi"
          class="custom_select"
          id="konsistensi"
          @input="
            setValue({
              label: 'konsistensi',
              $event,
            })
          "
        />
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col cols="12">
        <label class="text-title m-0">Pemeriksaan Intraoral</label>
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Goyang</label>
        <br>
        <vue-select
          :options="['Derajat I', 'Derajat II', 'Derajat III', 'Derajat IV']"
          v-model="formOdontogram.goyang"
          class="custom_select"
          id="goyang"
          @input="
            setValue({
              label: 'goyang',
              $event,
            })
          "
        />
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Perkusi</label>
        <br>
        <vue-select
          :options="['Positif', 'Negatif']"
          v-model="formOdontogram.perkusi"
          class="custom_select"
          id="perkusi"
          @input="
            setValue({
              label: 'perkusi',
              $event,
            })
          "
        />
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Warna Gusi</label>
        <br>
        <vue-select
          :options="['Normal', 'Kemerahan', 'Merah Kebiruan']"
          v-model="formOdontogram.warna_gusi"
          class="custom_select"
          id="warna_gusi"
          @input="
            setValue({
              label: 'warna_gusi',
              $event,
            })
          "
        />
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Druk</label>
        <br>
        <vue-select
          :options="['Positif', 'Negatif']"
          v-model="formOdontogram.druk"
          class="custom_select"
          id="druk"
          @input="
            setValue({
              label: 'druk',
              $event,
            })
          "
        />
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Karies Gigi</label>
        <br>
        <vue-select
          :options="['Decay', 'Missing', 'Filling']"
          v-model="formOdontogram.karies_gigi"
          class="custom_select"
          id="karies_gigi"
          @input="
            setValue({
              label: 'karies_gigi',
              $event,
            })
          "
        />
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Palpasi</label>
        <br>
        <vue-select
          :options="['Radang Gusi', 'Oklusi Gigi', 'Abses Gigi', 'Lesi']"
          v-model="formOdontogram.palpasi"
          class="custom_select"
          id="palpasi"
          @input="
            setValue({
              label: 'palpasi',
              $event,
            })
          "
        />
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Pembengkakan</label>
        <br>
        <vue-select
          :options="['Benjolan Keras', 'Benjolan Fluktuatif', 'Tidak Ada']"
          v-model="formOdontogram.pembengkakan"
          class="custom_select"
          id="pembengkakan"
          @input="
            setValue({
              label: 'pembengkakan',
              $event,
            })
          "
        />
      </b-col>
      <b-col cols="6" class="my-2">
        <label class="pr-0 text-subtitle">Status Karies</label>
        <br>
        <vue-select
          :options="['Sangat Rendah (0.8-1.1)', 'Rendah (1.2-2.6)', 'Sedang (2.7-4.4)', 'Tinggi (4.5-6.5)', 'Sangat Tinggi (>6.6)']"
          v-model="formOdontogram.status_karies"
          class="custom_select"
          id="status_karies"
          @input="
            setValue({
              label: 'status_karies',
              $event,
            })
          "
        />
      </b-col>
    </b-row>

    <div class="row d-flex align-items-end">
      <div class="col-md-6">&nbsp;</div>
      <div class="col-md-4 offset-md-2">
        <div class="row d-flex justify-content-end mr-2">
          <div class="col-md-6 text-right p-0">
            <font-awesome-icon
              icon="redo"
              class="font-size-xl m-2 grow icon pointer active_info"
              @click="clearOdontogram"
              v-tooltip="'Clear'"
            />
            <font-awesome-icon
              icon="keyboard"
              class="font-size-xl m-2 grow icon pointer"
              @click="setDrawPostData('keyboard');"
              :class="{ active_info: isActive === 'keyboard' }"
              v-tooltip="'Keyboard'"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12" ref="el_odontogram">
        <div class="odontogram text-center px-4 py-3" ref="div_odontogram">
          <svg ref="svg_odontogram" version="1.1" viewBox="0 0 1005 500" style="width:100%;height:auto;font-family:Arial,sans-serif;">
            <g transform="scale(3)" id="main-odontogram">
              <!-- top back -->
              <g :transform="`translate(${i*20},15)`" v-for="(tb, i) in numOdontogram.topBack" :key="tb">
                <text
                  x="7" y="-3" stroke="#515151" class="fill-51 fs-4" stroke-width="0.2"
                  @click="modalOdontogram(tb, 'all')"
                >{{ tb }}</text>
                <polygon
                  points="32,-15 45,-15 39,-5" stroke="#909399" stroke-width="0,2" opacity="1"
                  v-if="tb == 11" class="fill-90 scale-0-5"
                ></polygon>

                <template v-for="(tbv, tbkey) in findOdontogram(tb)">
                  <image
                    :key="tbv.no + i + tbkey" v-if="tbv.position == 'image' && tbv.no == 'arsir-cof'"
                    height="20" href="@/assets/img/garis-arsir-cof.png"
                  ></image>
                  <image
                    :key="tbv.no + i + tbkey" v-if="tbv.position == 'image' && ['arsir-fis','arsir-gif'].includes(tbv.no)"
                    height="20" href="@/assets/img/garis-arsir-fis.png"
                  ></image>
                  <image
                    :key="tbv.no + i + tbkey" v-if="tbv.position == 'image' && ['arsir-poc','arsir-pob'].includes(tbv.no)"
                    height="20" href="@/assets/img/garis-arsir.png"
                  ></image>

                  <polygon
                    :key="tbv.position" v-if="!['image','text'].includes(tbv.position)"
                    :class="tbv.class" :points="tbv.points"
                    :stroke="tbv.stroke" :stroke-width="tbv.stroke_width" :opacity="tbv.opacity"
                    @mouseenter="mouseenter(tb, tbv.position)" @mouseleave="mouseleave(tb, tbv.position)"
                    @click="modalOdontogram(tb, tbv.position)"
                  ></polygon>

                  <path
                    d="m32 245h29l17-69h61l-17 69h29l17-69h60v-24h-54l15-59h40v-24h-34l17-69h-29l-17 69h-61l17-69h-29l-17 69h-59v24h53l-14 59h-39v24h33l-17 69zm66-152h61l-15 59h-61l14-59z"
                    transform="scale(0.075) translate(10, 10)" fill="#000000" v-if="tbv.no == 'cfr'" :key="tbv.no + i + tbkey"
                  />
                  <text
                    :key="tbv.no + i + tbkey + '-text'" v-else-if="tbv.position == 'text'"
                    :x="setX(tbv.no)" :y="setY(tb, tbv.no)" class="text-uppercase fill-51 fs-3-5 fw-5"
                    :stroke="tbv.stroke" :stroke-width="tbv.stroke_width"
                  >{{ tbv.no }}</text>
                </template>
              </g>

              <!-- top front -->
              <g :id="tf" :transform="`translate(${(j*20)+60},55)`" v-for="(tf, j) in numOdontogram.topFront" :key="tf">
                <text
                  x="7" y="-3" stroke="#515151" class="fill-51 fs-4" stroke-width="0.2"
                  @click="modalOdontogram(tf, 'all')"
                >{{ tf }}</text>
                <polygon
                  points="32,55 45,55 39,43" stroke="#909399" stroke-width="0,2" opacity="1"
                  v-if="tf == 51" class="fill-90 scale-0-5"
                ></polygon>

                <template v-for="(tfv, tfkey) in findOdontogram(tf)">
                  <image
                    :key="tfv.no + j + tfkey" v-if="tfv.position == 'image' && tfv.no == 'arsir-cof'"
                    height="20" href="@/assets/img/garis-arsir-cof.png"
                  ></image>
                  <image
                    :key="tfv.no + j + tfkey" v-if="tfv.position == 'image' && ['arsir-fis','arsir-gif'].includes(tfv.no)"
                    height="20" href="@/assets/img/garis-arsir-fis.png"
                  ></image>
                  <image
                    :key="tfv.no + j + tfkey" v-if="tfv.position == 'image' && ['arsir-poc','arsir-pob'].includes(tfv.no)"
                    height="20" href="@/assets/img/garis-arsir.png"
                  ></image>

                  <polygon
                    :key="tfv.position" v-if="!['image','text'].includes(tfv.position)"
                    :class="tfv.class" :points="tfv.points"
                    :stroke="tfv.stroke" :stroke-width="tfv.stroke_width" :opacity="tfv.opacity"
                    @mouseenter="mouseenter(tf, tfv.position)" @mouseleave="mouseleave(tf, tfv.position)"
                    @click="modalOdontogram(tf, tfv.position)"
                  ></polygon>

                  <path
                    d="m32 245h29l17-69h61l-17 69h29l17-69h60v-24h-54l15-59h40v-24h-34l17-69h-29l-17 69h-61l17-69h-29l-17 69h-59v24h53l-14 59h-39v24h33l-17 69zm66-152h61l-15 59h-61l14-59z"
                    transform="scale(0.075) translate(10, 10)" fill="#000000" v-if="tfv.no == 'cfr'" :key="tfv.no + j + tfkey"
                  />
                  <text
                    :key="tfv.no + j + tfkey + '-text'" v-else-if="tfv.position == 'text'"
                    :x="setX(tfv.no)" :y="setY(tf, tfv.no)" class="text-uppercase fill-51 fs-3-5 fw-5"
                    :stroke="tfv.stroke" :stroke-width="tfv.stroke_width"
                  >{{ tfv.no }}</text>
                </template>
              </g>

              <!-- bottom back -->
              <g :id="bb" :transform="`translate(${(x*20)+60},90)`" v-for="(bb, x) in numOdontogram.bottomFront" :key="bb">
                <text
                  x="7" y="28" stroke="#515151" class="fill-51 fs-4" stroke-width="0.2"
                  @click="modalOdontogram(bb, 'all')"
                >{{ bb }}</text>
                <polygon
                  points="32,-13 45,-13 39,-2" stroke="#909399" stroke-width="0,2" opacity="1"
                  v-if="bb == 81" class="fill-90 scale-0-5"
                ></polygon>

                <template v-for="(bbv, bbkey) in findOdontogram(bb)">
                  <image
                    :key="bbv.no + x + bbkey" v-if="bbv.position == 'image' && bbv.no == 'arsir-cof'"
                    height="20" href="@/assets/img/garis-arsir-cof.png"
                  ></image>
                  <image
                    :key="bbv.no + x + bbkey" v-if="bbv.position == 'image' && ['arsir-fis','arsir-gif'].includes(bbv.no)"
                    height="20" href="@/assets/img/garis-arsir-fis.png"
                  ></image>
                  <image
                    :key="bbv.no + x + bbkey" v-if="bbv.position == 'image' && ['arsir-poc','arsir-pob'].includes(bbv.no)"
                    height="20" href="@/assets/img/garis-arsir.png"
                  ></image>

                  <polygon
                    :key="bbv.position" v-if="!['image','text'].includes(bbv.position)"
                    :class="bbv.class" :points="bbv.points"
                    :stroke="bbv.stroke" :stroke-width="bbv.stroke_width" :opacity="bbv.opacity"
                    @mouseenter="mouseenter(bb, bbv.position)" @mouseleave="mouseleave(bb, bbv.position)"
                    @click="modalOdontogram(bb, bbv.position)"
                  ></polygon>

                  <path
                    d="m32 245h29l17-69h61l-17 69h29l17-69h60v-24h-54l15-59h40v-24h-34l17-69h-29l-17 69h-61l17-69h-29l-17 69h-59v24h53l-14 59h-39v24h33l-17 69zm66-152h61l-15 59h-61l14-59z"
                    transform="scale(0.075) translate(10, 10)" fill="#000000" v-if="bbv.no == 'cfr'" :key="bbv.no + x + bbkey"
                  />
                  <text
                    :key="bbv.no + x + bbkey + '-text'" v-else-if="bbv.position == 'text'"
                    :x="setX(bbv.no)" :y="setY(bb, bbv.no)" class="text-uppercase fill-51 fs-3-5 fw-5"
                    :stroke="bbv.stroke" :stroke-width="bbv.stroke_width"
                  >{{ bbv.no }}</text>
                </template>
              </g>

              <!-- bottom front -->
              <g :id="bf" :transform="`translate(${y*20},130)`" v-for="(bf, y) in numOdontogram.bottomBack" :key="bf">
                <text
                  x="6" y="28" stroke="#515151" class="fill-51 fs-4" stroke-width="0.2"
                  @click="modalOdontogram(bf, 'all')"
                >{{ bf }}</text>
                <polygon
                  points="32,57 45,57 39,45" stroke="#909399" stroke-width="0,2" opacity="1"
                  v-if="bf == 41" class="fill-90 scale-0-5"
                ></polygon>

                <template v-for="(bfv, bfkey) in findOdontogram(bf)">
                  <image
                    :key="bfv.no + y + bfkey" v-if="bfv.position == 'image' && bfv.no == 'arsir-cof'"
                    height="20" href="@/assets/img/garis-arsir-cof.png"
                  ></image>
                  <image
                    :key="bfv.no + y + bfkey" v-if="bfv.position == 'image' && ['arsir-fis','arsir-gif'].includes(bfv.no)"
                    height="20" href="@/assets/img/garis-arsir-fis.png"
                  ></image>
                  <image
                    :key="bfv.no + y + bfkey" v-if="bfv.position == 'image' && ['arsir-poc','arsir-pob'].includes(bfv.no)"
                    height="20" href="@/assets/img/garis-arsir.png"
                  ></image>

                  <polygon
                    :key="bfv.position" v-if="!['image','text'].includes(bfv.position)"
                    :class="bfv.class" :points="bfv.points"
                    :stroke="bfv.stroke" :stroke-width="bfv.stroke_width" :opacity="bfv.opacity"
                    @mouseenter="mouseenter(bf, bfv.position)" @mouseleave="mouseleave(bf, bfv.position)"
                    @click="modalOdontogram(bf, bfv.position)"
                  ></polygon>

                  <path
                    d="m32 245h29l17-69h61l-17 69h29l17-69h60v-24h-54l15-59h40v-24h-34l17-69h-29l-17 69h-61l17-69h-29l-17 69h-59v24h53l-14 59h-39v24h33l-17 69zm66-152h61l-15 59h-61l14-59z"
                    transform="scale(0.075) translate(10, 10)" fill="#000000" v-if="bfv.no == 'cfr'" :key="bfv.no + y + bfkey"
                  />
                  <text
                    :key="bfv.no + y + bfkey + '-text'" v-else-if="bfv.position == 'text'"
                    :x="setX(bfv.no)" :y="setY(bf, bfv.no)" class="text-uppercase fill-51 fs-3-5 fw-5"
                    :stroke="bfv.stroke" :stroke-width="bfv.stroke_width"
                  >{{ bfv.no }}</text>
                </template>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="col-md-12 mt-3 text-center" v-show="false">
        <canvas
          id="odontogram-canvas"
          ref="canvas"
          @mousedown="handleMousedown"
          @mouseup="handleMouseup"
          @mousemove="handleMousemove"
          @touchstart="handleTouchstart"
          @touchend="handleTouchend"
          @touchmove="handleTouchmove"
          :width="odontogramWidth"
          :height="odontogramHeight"
        >Your browser does not support the HTML 5 Canvas.
        </canvas>
      </div>
      <div v-if="isActive == 'keyboard'" class="col-md-12 mt-3">
        <Editor
          id="editor"
          class="form-odontogram"
          :width="contentWidth"
          :editorContent="odontogram_notes"
          v-on:update-content="updateContent"
        />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 media">
        <div class="media-body">
          <label for="kondisi-gigi" class="text-title">Kondisi Gigi</label>
        </div>
        <div>
          <font-awesome-layers
            style="font-size: 2rem;cursor: pointer;"
            v-tooltip="'simbol-simbol odontogram'"
            @click="modalSimbolOdontogram"
          >
            <font-awesome-icon
              :icon="['far', 'circle']"
              class="color-info"
            />
            <font-awesome-icon
              :icon="['fas', 'info']"
              style="cursor: pointer;font-size: 1rem;"
              class="color-info"
            />
          </font-awesome-layers>
        </div>
      </div>
        
      <div class="col-md-12 table-responsive mt-3">
        <b-table
          :fixed="true"
          :items="listConditionGigi"
          :fields="fieldListGigi"
          :borderless="true"
          class="custom_border"
        >
          <template v-slot:cell()="data">
            <p v-if="data.item.is_blank">&nbsp;</p>
            <p v-else>{{ data.value && data.value != '' ? data.value : '-' }}</p>
          </template>
          <template v-slot:cell(icdx)="data">
            <p v-for="(v, i) in data.item.icdx" :key="i">{{ v && v != '' ? v : '-' }}</p>
          </template>
          <template v-slot:cell(keterangan)="data">
            <div class="media" v-if="!data.item.is_blank">
              <div class="media-body">
                {{ data.value && data.value != '' ? data.value : '-' }}
              </div>
              <div>
                <font-awesome-icon
                  @click="deleteKondisiGigi(data.item)"
                  :icon="['fas', 'trash-alt']"
                  style="cursor: pointer;font-size: 1rem;"
                  class="text-danger"
                />
              </div>
            </div>
          </template>
        </b-table>
        <hr class="mt-5">
      </div>

      <div class="col-md-12 mb-3">
        <div class="row my-2">
          <div class="col-md-6">
            <label class="pr-0 text-subtitle">Occlusi</label>
            <br>
            <vue-select
              :options="['Normal Bite', 'Cross Bite', 'Steep Bite']"
              v-model="formOdontogram.occlusi"
              class="custom_select"
              id="occlusi"
              @input="
                setValue({
                  label: 'occlusi',
                  $event,
                })
              "
            />
          </div>
          <div class="col-md-2">
            <label class="pr-0 text-subtitle">Diastema</label>
            <br>
            <vue-select
              :options="['Ada', 'Tidak Ada']"
              v-model="formOdontogram.diastema"
              placeholder="Pilih"
              class="custom_select"
              id="diastema"
              @input="
                setValue({
                  label: 'diastema',
                  $event,
                })
              "
            />
          </div>
          <div class="col-md-4">
            <br />
            <b-form-input
              ref="ket_diastema"
              type="text"
              v-model.lazy="formOdontogram.ket_diastema"
              class="mt-2"
              placeholder="Tuliskan di mana dan berapa lebar"
              @input="
                setValue({
                  label: 'ket_diastema',
                  $event,
                })
              "
              :disabled="!formOdontogram.diastema || (formOdontogram.diastema && formOdontogram.diastema != 'Ada')"
            />
          </div>
        </div>
        
        <div class="row my-2">
          <div class="col-md-6">
            <label class="pr-0 text-subtitle">Torus Palatinus</label>
            <br>
            <vue-select
              :options="['Tidak Ada', 'Kecil', 'Sedang', 'Besar', 'Multiple']"
              v-model="formOdontogram.torus_palatinus"
              class="custom_select"
              id="torus_palatinus"
              @input="
                setValue({
                  label: 'torus_palatinus',
                  $event,
                })
              "
            />
          </div>
          <div class="col-md-2">
            <label class="pr-0 text-subtitle">Gigi Anomali</label>
            <br>
            <vue-select
              :options="['Ada', 'Tidak Ada']"
              v-model="formOdontogram.gigi_anomali"
              placeholder="Pilih"
              class="custom_select"
              id="gigi_anomali"
              @input="
                setValue({
                  label: 'gigi_anomali',
                  $event,
                })
              "
            />
          </div>
          <div class="col-md-4">
            <br />
            <b-form-input
              ref="ket_gigi_anomali"
              type="text"
              v-model.lazy="formOdontogram.ket_gigi_anomali"
              class="mt-2"
              placeholder="Tuliskan gigi yang mana dan bentuknya"
              @input="
                setValue({
                  label: 'ket_gigi_anomali',
                  $event,
                })
              "
              :disabled="!formOdontogram.gigi_anomali || (formOdontogram.gigi_anomali && formOdontogram.gigi_anomali != 'Ada')"
            />
          </div>
        </div>
        
        <div class="row my-2">
          <div class="col-md-6">
            <label class="pr-0 text-subtitle">Torus Mandibularis</label>
            <br>
            <vue-select
              :options="['Tidak Ada', 'Sisi Kiri', 'Sisi Kanan', 'Kedua Sisi']"
              v-model="formOdontogram.torus_mandibularis"
              class="custom_select"
              id="torus_mandibularis"
              @input="
                setValue({
                  label: 'torus_mandibularis',
                  $event,
                })
              "
            />
          </div>
          <div class="col-md-6">
            <label class="pr-0 text-subtitle">Lain - Lain</label>
            <br />
            <b-form-input
              ref="lain_lain"
              type="text"
              v-model.lazy="formOdontogram.lain_lain"
              @input="
                setValue({
                  label: 'lain_lain',
                  $event,
                })
              "
            />
          </div>
        </div>
        
        <div class="row my-2">
          <div class="col-md-6">
            <label class="pr-0 text-subtitle">Palatum</label>
            <br>
            <vue-select
              :options="['Dalam', 'Sedang', 'Rendah']"
              v-model="formOdontogram.palatum"
              class="custom_select"
              id="palatum"
              @input="
                setValue({
                  label: 'palatum',
                  $event,
                })
              "
            />
          </div>
          <div class="col-md-2">
            <label class="pr-0 text-subtitle">D</label>
            <br />
            <b-form-input
              ref="ket_d"
              type="text"
              v-model.lazy="formOdontogram.ket_d"
              @input="
                setValue({
                  label: 'ket_d',
                  $event,
                })
              "
            />
          </div>
          <div class="col-md-2">
            <label class="pr-0 text-subtitle">M</label>
            <br />
            <b-form-input
              ref="ket_m"
              type="text"
              v-model.lazy="formOdontogram.ket_m"
              @input="
                setValue({
                  label: 'ket_m',
                  $event,
                })
              "
            />
          </div>
          <div class="col-md-2">
            <label class="pr-0 text-subtitle">F</label>
            <br />
            <b-form-input
              ref="ket_f"
              type="text"
              v-model.lazy="formOdontogram.ket_f"
              @input="
                setValue({
                  label: 'ket_f',
                  $event,
                })
              "
            />
          </div>
        </div>
        
        <div class="row mt-2">
          <div class="col-md-6">
            <label class="pr-0 text-subtitle">Jumlah photo yang diambil</label>
            <br />
              <div class="media">
              <div class="media-left mr-3">
                <b-form-input
                  ref="qty_photo"
                  type="text"
                  v-model.lazy="formOdontogram.qty_photo"
                  @input="
                    setValue({
                      label: 'qty_photo',
                      $event,
                    })
                  "
                />
              </div>
              <div class="media-body">
                <vue-select
                  :options="['Digital', 'Intraoral']"
                  v-model="formOdontogram.satuan_photo"
                  placeholder="Satuan"
                  class="custom_select __select-photo"
                  id="satuan_photo"
                  @input="
                    setValue({
                      label: 'satuan_photo',
                      $event,
                    })
                  "
                />
              </div>
              </div>
          </div>
          <div class="col-md-6">
            <label class="pr-0 text-subtitle">Jumlah rontgen photo yang diambil</label>
            <br />
              <div class="media">
              <div class="media-left mr-3">
                <b-form-input
                  ref="qty_rontgen"
                  type="text"
                  v-model.lazy="formOdontogram.qty_rontgen"
                  @input="
                    setValue({
                      label: 'qty_rontgen',
                      $event,
                    })
                  "
                />
              </div>
              <div class="media-body">
                <vue-select
                  :options="['Dental', 'PA', 'OPG', 'Ceph']"
                  v-model="formOdontogram.satuan_rontgen"
                  placeholder="Satuan"
                  class="custom_select __select-photo"
                  id="satuan_rontgen"
                  @input="
                    setValue({
                      label: 'satuan_rontgen',
                      $event,
                    })
                  "
                />
              </div>
              </div>
          </div>
        </div>
      </div>
    </div>

    <b-row class="mt-4">
      <b-col cols="12">
        <label class="text-title m-0">Index Kebersihan Gigi dan Mulut (OHIS)</label>
      </b-col>
      <b-col cols="5">
        <label class="pr-0 text-subtitle">
          Debris Index (DI)
        </label>
        <b-row class="ml-1">
          <b-col cols="4" class="text-center pl-0">
            <label class="pr-0 text-subtitle">16</label>
            <br />
            <b-form-input
              id="debris_index_16"
              type="text" class="text-center"
              v-model.lazy="formOHIS.debris_index_16"
              @keypress="inputOnlyNumber"
              :maxlength="1"
              @input="
                setValueOHIS({
                  label: 'debris_index_16',
                  $event,
                })
              "
            />
          </b-col>
          <b-col cols="4" class="text-center pl-0">
            <label class="pr-0 text-subtitle">11</label>
            <br />
            <b-form-input
              id="debris_index_11"
              type="text" class="text-center"
              v-model.lazy="formOHIS.debris_index_11"
              @keypress="inputOnlyNumber"
              :maxlength="1"
              @input="
                setValueOHIS({
                  label: 'debris_index_11',
                  $event,
                })
              "
            />
          </b-col>
          <b-col cols="4" class="text-center pl-0">
            <label class="pr-0 text-subtitle">26</label>
            <br />
            <b-form-input
              id="debris_index_26"
              type="text" class="text-center"
              v-model.lazy="formOHIS.debris_index_26"
              @keypress="inputOnlyNumber"
              :maxlength="1"
              @input="
                setValueOHIS({
                  label: 'debris_index_26',
                  $event,
                })
              "
            />
          </b-col>
          <b-col cols="4" class="text-center pl-0 mt-3">
            <label class="pr-0 text-subtitle">36</label>
            <br />
            <b-form-input
              id="debris_index_36"
              type="text" class="text-center"
              v-model.lazy="formOHIS.debris_index_36"
              @keypress="inputOnlyNumber"
              :maxlength="1"
              @input="
                setValueOHIS({
                  label: 'debris_index_36',
                  $event,
                })
              "
            />
          </b-col>
          <b-col cols="4" class="text-center pl-0 mt-3">
            <label class="pr-0 text-subtitle">31</label>
            <br />
            <b-form-input
              id="debris_index_31"
              type="text" class="text-center"
              v-model.lazy="formOHIS.debris_index_31"
              @keypress="inputOnlyNumber"
              :maxlength="1"
              @input="
                setValueOHIS({
                  label: 'debris_index_31',
                  $event,
                })
              "
            />
          </b-col>
          <b-col cols="4" class="text-center pl-0 mt-3">
            <label class="pr-0 text-subtitle">46</label>
            <br />
            <b-form-input
              id="debris_index_46"
              type="text" class="text-center"
              v-model.lazy="formOHIS.debris_index_46"
              @keypress="inputOnlyNumber"
              :maxlength="1"
              @input="
                setValueOHIS({
                  label: 'debris_index_46',
                  $event,
                })
              "
            />
          </b-col>
          <b-col cols="12 p-0" v-if="checkValueData(errOHIS.debris)">
            <small class="text-danger">{{ errOHIS.debris }}</small>
          </b-col>
        </b-row>
        <label class="pr-0 text-subtitle mt-3">
          Total Skor Debris Index (DI)
        </label>
        <b-row class="ml-1 total">
          <b-col cols="3" class="p-0">
            <b-form-input
              id="subtotal_debris_index"
              type="text" class="text-center"
              v-model.lazy="formOHIS.subtotal_debris_index"
              @keypress="inputOnlyNumberSpecial"
              readonly
            />
          </b-col>
          <b-col cols="1" class="text-center p-0 mt-2">
            <span v-html="icon.division"></span>
          </b-col>
          <b-col cols="3" class="p-0">
            <b-form-input
              id="count_debris_index"
              type="text" class="text-center"
              v-model.lazy="formOHIS.count_debris_index"
              @keypress="inputOnlyNumberSpecial"
              readonly
            />
          </b-col>
          <b-col cols="1" class="text-center p-0 mt-2">
            <h4 v-html="icon.equals"></h4>
          </b-col>
          <b-col cols="3" class="p-0">
            <b-form-input
              id="total_debris_index"
              type="text" class="text-center"
              v-model.lazy="formOHIS.total_debris_index"
              @keypress="inputOnlyNumberSpecial"
              readonly
            />
          </b-col>
        </b-row>
        <label class="pr-0 text-subtitle mt-3">
          Skor Total OHIS= DI + CI =
        </label>
        <b-row class="ml-1 total">
          <b-col cols="3" class="p-0">
            <b-form-input
              id="total_debris_ohis"
              type="text" class="text-center"
              v-model.lazy="formOHIS.total_debris_index"
              @keypress="inputOnlyNumberSpecial"
              readonly
            />
          </b-col>
          <b-col cols="1" class="text-center p-0 mt-2">
            <h4 v-html="icon.plus"></h4>
          </b-col>
          <b-col cols="3" class="p-0">
            <b-form-input
              id="total_kalkulus_ohis"
              type="text" class="text-center"
              v-model.lazy="formOHIS.total_kalkulus_index"
              @keypress="inputOnlyNumberSpecial"
              readonly
            />
          </b-col>
          <b-col cols="1" class="text-center p-0 mt-2">
            <h4 v-html="icon.equals"></h4>
          </b-col>
          <b-col cols="3" class="p-0">
            <b-form-input
              id="total_ohis"
              type="text" class="text-center"
              v-model.lazy="formOHIS.total_ohis"
              @keypress="inputOnlyNumberSpecial"
              readonly
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="5" class="offset-1">
        <label class="pr-0 text-subtitle">
          Kalkulus Index (CI)
        </label>
        <b-row class="ml-1">
          <b-col cols="4" class="text-center pl-0">
            <label class="pr-0 text-subtitle">16</label>
            <br />
            <b-form-input
              id="kalkulus_index_16"
              type="text" class="text-center"
              v-model.lazy="formOHIS.kalkulus_index_16"
              @keypress="inputOnlyNumber"
              :maxlength="1"
              @input="
                setValueOHIS({
                  label: 'kalkulus_index_16',
                  $event,
                })
              "
            />
          </b-col>
          <b-col cols="4" class="text-center pl-0">
            <label class="pr-0 text-subtitle">11</label>
            <br />
            <b-form-input
              id="kalkulus_index_11"
              type="text" class="text-center"
              v-model.lazy="formOHIS.kalkulus_index_11"
              @keypress="inputOnlyNumber"
              :maxlength="1"
              @input="
                setValueOHIS({
                  label: 'kalkulus_index_11',
                  $event,
                })
              "
            />
          </b-col>
          <b-col cols="4" class="text-center pl-0">
            <label class="pr-0 text-subtitle">26</label>
            <br />
            <b-form-input
              id="kalkulus_index_26"
              type="text" class="text-center"
              v-model.lazy="formOHIS.kalkulus_index_26"
              @keypress="inputOnlyNumber"
              :maxlength="1"
              @input="
                setValueOHIS({
                  label: 'kalkulus_index_26',
                  $event,
                })
              "
            />
          </b-col>
          <b-col cols="4" class="text-center pl-0 mt-3">
            <label class="pr-0 text-subtitle">36</label>
            <br />
            <b-form-input
              id="kalkulus_index_36"
              type="text" class="text-center"
              v-model.lazy="formOHIS.kalkulus_index_36"
              @keypress="inputOnlyNumber"
              :maxlength="1"
              @input="
                setValueOHIS({
                  label: 'kalkulus_index_36',
                  $event,
                })
              "
            />
          </b-col>
          <b-col cols="4" class="text-center pl-0 mt-3">
            <label class="pr-0 text-subtitle">31</label>
            <br />
            <b-form-input
              id="kalkulus_index_31"
              type="text" class="text-center"
              v-model.lazy="formOHIS.kalkulus_index_31"
              @keypress="inputOnlyNumber"
              :maxlength="1"
              @input="
                setValueOHIS({
                  label: 'kalkulus_index_31',
                  $event,
                })
              "
            />
          </b-col>
          <b-col cols="4" class="text-center pl-0 mt-3">
            <label class="pr-0 text-subtitle">46</label>
            <br />
            <b-form-input
              id="kalkulus_index_46"
              type="text" class="text-center"
              v-model.lazy="formOHIS.kalkulus_index_46"
              @keypress="inputOnlyNumber"
              :maxlength="1"
              @input="
                setValueOHIS({
                  label: 'kalkulus_index_46',
                  $event,
                })
              "
            />
          </b-col>
          <b-col cols="12 p-0" v-if="checkValueData(errOHIS.kalkulus)">
            <small class="text-danger">{{ errOHIS.kalkulus }}</small>
          </b-col>
        </b-row>
        <label class="pr-0 text-subtitle mt-3">
          Total Skor Kalkulus Index (CI)
        </label>
        <b-row class="ml-1 total">
          <b-col cols="3" class="p-0">
            <b-form-input
              id="subtotal_kalkulus_index"
              type="text" class="text-center"
              v-model.lazy="formOHIS.subtotal_kalkulus_index"
              @keypress="inputOnlyNumberSpecial"
              readonly
            />
          </b-col>
          <b-col cols="1" class="text-center p-0 mt-2">
            <span v-html="icon.division"></span>
          </b-col>
          <b-col cols="3" class="p-0">
            <b-form-input
              id="count_kalkulus_index"
              type="text" class="text-center"
              v-model.lazy="formOHIS.count_kalkulus_index"
              @keypress="inputOnlyNumberSpecial"
              readonly
            />
          </b-col>
          <b-col cols="1" class="text-center p-0 mt-2">
            <h4 v-html="icon.equals"></h4>
          </b-col>
          <b-col cols="3" class="p-0">
            <b-form-input
              id="total_kalkulus_index"
              type="text" class="text-center"
              v-model.lazy="formOHIS.total_kalkulus_index"
              @keypress="inputOnlyNumberSpecial"
              readonly
            />
          </b-col>
        </b-row>
        <label class="pr-0 text-subtitle mt-3">
          Kriteria OHI-S
        </label>
        <table class="ml-1 table-kriteria-border">
          <tr>
            <td class="text-subtitle">Baik</td>
            <td class="text-subtitle">= 0 - 1,2</td>
          </tr>
          <tr>
            <td class="text-subtitle">Sedang</td>
            <td class="text-subtitle">= 1,3 - 3,0</td>
          </tr>
          <tr>
            <td class="text-subtitle">Buruk</td>
            <td class="text-subtitle">= 3,1 - 6,0</td>
          </tr>
        </table>
      </b-col>
    </b-row>

    <!-- Modal Simbol Odontogram -->
    <b-modal
      ref="simbol-odontogram" size="lg"
      hide-header hide-footer
    >
      <b-row>
        <b-col sm="12" class="text-center text-title p-0">
          <label for="header">Simbol - Simbol Odontogram</label>
          <hr class="mt-0">
        </b-col>
        <b-col sm="12" class="px-5 py-2" v-for="(simbol, idx) in simbolOdontogram.data" :key="idx">
          <b-row>
            <b-col :sm="simbolOdontogram.col_left" class="pr-0">
              <div class="text-center">
                <svg version="1.1" width="100%" height="107">
                    <g transform="scale(3)">
                      <g :transform="`translate(${i*20},8)`" v-for="(v, i) in simbol.odontogram" :key="i">
                        <template v-for="(val, vkey) in v">
                          <image
                            :key="idx + vkey" v-if="val.position == 'image' && val.no == 'arsir-cof'"
                            height="20" href="@/assets/img/garis-arsir-cof.png"
                          ></image>
                          <image
                            :key="idx + vkey" v-if="val.position == 'image' && ['arsir-fis','arsir-gif'].includes(val.no)"
                            height="20" href="@/assets/img/garis-arsir-fis.png"
                          ></image>
                          <image
                            :key="idx + vkey" v-if="val.position == 'image' && ['arsir-poc','arsir-pob'].includes(val.no)"
                            height="20" href="@/assets/img/garis-arsir.png"
                          ></image>
                          <image
                            :key="idx + vkey" v-if="val.position == 'image' && val.no == 'arsir-l'"
                            height="8" x="2" y="-8" href="@/assets/img/arrow-l.png"
                          ></image>
                          <image
                            :key="idx + vkey" v-if="val.position == 'image' && val.no == 'arsir-r'"
                            height="8" x="2" y="-8" href="@/assets/img/arrow-r.png"
                          ></image>
                          <image
                            :key="idx + vkey" v-if="val.position == 'image' && val.no == 'arsir-t'"
                            height="8" x="4" y="-8" href="@/assets/img/arrow-t.png"
                          ></image>
                          <image
                            :key="idx + vkey" v-if="val.position == 'image' && val.no == 'arsir-b'"
                            height="8" x="4" y="20" href="@/assets/img/arrow-b.png"
                          ></image>

                          <polygon
                            :key="val.position" v-if="!['image','text'].includes(val.position)"
                            :class="val.class" :points="val.points"
                            :stroke="val.stroke" :stroke-width="val.stroke_width" :opacity="val.opacity"
                          ></polygon>

                          <path
                            d="m32 245h29l17-69h61l-17 69h29l17-69h60v-24h-54l15-59h40v-24h-34l17-69h-29l-17 69h-61l17-69h-29l-17 69h-59v24h53l-14 59h-39v24h33l-17 69zm66-152h61l-15 59h-61l14-59z"
                            transform="scale(0.075) translate(10, 10)" fill="#000000" v-if="val.no == 'cfr'" :key="val.no + vkey + '-#'"
                          />
                          <text
                            :key="idx + vkey + '-text'" v-else-if="val.position == 'text'"
                            :x="setX(val.no)" :y="setY(val.no, val.no, true)" class="text-uppercase fill-51 fs-4 fw-6"
                            :stroke="val.stroke" :stroke-width="val.stroke_width"
                          >{{ val.no }}</text>
                        </template>
                      </g>
                    </g>
                </svg>
              </div>
            </b-col>
            <b-col :sm="simbolOdontogram.col_right" class="pl-0">
              <div class="media media-desc">
                <div class="text-center" style="width: 25px;">:</div>
                <div class="media-body">
                  <p v-html="simbol.description" class="m-0"></p>
                  <div class="media ml-5 pl-5 mt-2" v-if="simbol.code == 'cof'">
                    <img src="@/assets/img/garis-arsir-small.png" alt="arsir" style="border: 2px solid #515151" />
                    <div class="media-body mt-2 ml-3">= &nbsp;&nbsp;&nbsp; di arsir</div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12">
          <ul role="menubar" class="pagination b-pagination justify-content-center">
            <li role="presentation" class="page-item" :class="{'disabled': simbolOdontogram.page == 1}">
              <span role="menuitem" class="page-link m-0" v-if="simbolOdontogram.page == 1">‹</span>
              <button role="menuitem" type="button" class="page-link m-0 color-info" v-else @click="pagesimbol('previous')">‹</button>
            </li>
            <li role="presentation" class="page-item">
              <span role="menuitem" class="page-link page-info m-0 color-info">{{ simbolOdontogram.page }}</span>
            </li>
            <li role="presentation" class="page-item" :class="{'disabled': simbolOdontogram.page == simbolOdontogram.last_page}">
              <span role="menuitem" class="page-link m-0" v-if="simbolOdontogram.page == simbolOdontogram.last_page">‹</span>
              <button role="menuitem" type="button" class="page-link m-0 color-info" @click="pagesimbol('next')" v-else>›</button>
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Modal Simbol Odontogram -->

    <!-- Modal Odontogram -->
    <b-modal
      id="modal-odontogram"
      ref="modal-odontogram" size="xl"
      hide-header hide-footer
      :no-close-on-backdrop="true"
    >
      <div v-for="(odon, idx) in tmpInputData" :key="idx">
        <hr :key="idx + 'hr'" v-if="idx > 0" class="hr-odo">
        <div class="media pr-5 py-3">
          <div class="text-center" style="width: 225px;">
            <label for="info" class="text-title">Kondisi Gigi</label>
            <svg version="1.1" width="100%" height="500">
                <g transform="scale(5)">
                  <g transform="translate(12.5,10)">
                    <text
                      x="8" y="35" stroke="#515151"
                      class="fill-51 fs-2-5" stroke-width="0.2"
                      @click="selectedOdontogram(idx, 'all')"
                    >{{ odon.no }}</text>

                    <template v-for="(val, vkey) in odon.odontogram">
                      <image
                        :key="idx + vkey" v-if="val.position == 'image' && val.no == 'arsir-cof'"
                        height="20" href="@/assets/img/garis-arsir-cof.png"
                      ></image>
                      <image
                        :key="idx + vkey" v-if="val.position == 'image' && ['arsir-fis','arsir-gif'].includes(val.no)"
                        height="20" href="@/assets/img/garis-arsir-fis.png"
                      ></image>
                      <image
                        :key="idx + vkey" v-if="val.position == 'image' && ['arsir-poc','arsir-pob'].includes(val.no)"
                        height="20" href="@/assets/img/garis-arsir.png"
                      ></image>

                      <polygon
                        :key="idx + vkey" v-if="!['image','text'].includes(val.position)"
                        :class="val.class" :points="val.points"
                        :stroke="val.stroke" :stroke-width="val.stroke_width" :opacity="val.opacity"
                        @click="selectedOdontogram(idx, val.position)"
                      ></polygon>

                      <path
                          d="m32 245h29l17-69h61l-17 69h29l17-69h60v-24h-54l15-59h40v-24h-34l17-69h-29l-17 69h-61l17-69h-29l-17 69h-59v24h53l-14 59h-39v24h33l-17 69zm66-152h61l-15 59h-61l14-59z"
                          transform="scale(0.075) translate(10, 10)" fill="#000000" v-if="val.no == 'cfr'" :key="val.no + vkey + '-#'"
                        />
                      <text
                        :key="idx + vkey + '-text'" v-else-if="val.position == 'text'"
                        :x="setX(val.no)" :y="setY(val.no, val.no, true)" class="text-uppercase fill-51 fs-3 fw-5"
                        :stroke="val.stroke" :stroke-width="val.stroke_width"
                      >{{ val.no }}</text>
                    </template>
                  </g>
                </g>
            </svg>
          </div>
          <div class="media-body">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="pr-0 text-subtitle">Permukaan Gigi</label>
                <br>
                <vue-select
                  :options="option_permukaan_gigi"
                  v-model="odon.permukaan_gigi"
                  class="custom_select"
                  id="permukaan_gigi"
                  keyOpt="odontogram"
                  @input="
                    setValueModal({
                      idx,
                      label: 'permukaan_gigi',
                      $event,
                    })
                  "
                >
                </vue-select>
                <b-form-invalid-feedback>
                  {{ odon.errors && odon.errors.permukaan_gigi.desc }}
                </b-form-invalid-feedback>
              </div>
              <div class="col-md-6 mb-3 text-right">
                <b-button
                  v-if="idx > 0"
                  variant="danger"
                  class="icon-minus"
                  @click="removeInputData(idx)"
                >
                  <font-awesome-icon icon="minus" />
                </b-button>
              </div>
              <div class="col-md-6 mb-3">
                <label class="pr-0 text-subtitle">Keadaan Gigi</label>
                <br>
                <multiselect
                  :options="option_keadaan_gigi"
                  v-model="odon.keadaan_gigi"
                  label="label"
                  track-by="label"
                  :multiple="true"
                  open-direction="bottom"
                  class="custom_multiselect"
                  placeholder=""
                  @input="
                    setValueModal({
                      idx,
                      label: 'keadaan_gigi',
                      $event,
                    })
                  "
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="pr-0 text-subtitle">Bahan Restorasi</label>
                <br>
                <multiselect
                  :options="option_bahan_restorasi"
                  v-model="odon.bahan_restorasi"
                  label="label"
                  track-by="label"
                  :multiple="true"
                  open-direction="bottom"
                  class="custom_multiselect"
                  placeholder=""
                  @input="
                    setValueModal({
                      idx,
                      label: 'bahan_restorasi',
                      $event,
                    })
                  "
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="pr-0 text-subtitle">Restorasi</label>
                <br>
                <multiselect
                  :options="option_restorasi"
                  v-model="odon.restorasi"
                  label="label"
                  track-by="label"
                  :multiple="true"
                  open-direction="bottom"
                  class="custom_multiselect"
                  placeholder=""
                  @input="
                    setValueModal({
                      idx,
                      label: 'restorasi',
                      $event,
                    })
                  "
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="pr-0 text-subtitle">Protesa</label>
                <br>
                <multiselect
                  :options="option_protesa"
                  v-model="odon.protesa"
                  label="label"
                  track-by="label"
                  :multiple="true"
                  open-direction="bottom"
                  class="custom_multiselect"
                  placeholder=""
                  @input="
                    setValueModal({
                      idx,
                      label: 'protesa',
                      $event,
                    })
                  "
                />
              </div>
              <div class="col-md-12 mb-3">
                <label class="pr-0 text-subtitle">ICD 10</label>
                <br>
                <multiselect
                  :options="option_icd_x"
                  v-model="odon.icd_x"
                  :multiple="true"
                  placeholder="Masukkan Kode atau Diagnosis / Penyakit"
                  label="description"
                  track-by="description"
                  :loading="isLoading"
                  :hide-selected="true"
                  :options-limit="10"
                  :limit="3"
                  open-direction="bottom"
                  :limit-text="limitText"
                  @search-change="debounceICDX($event)"
                  class="custom_multiselect"
                  @input="
                    setValueModal({
                      idx,
                      label: 'icd_x',
                      $event,
                    })
                  "
                />
              </div>
              <div class="col-md-12 mb-3">
                <label class="pr-0 text-subtitle">Keterangan Tambahan</label>
                <br>
                <textarea
                  v-model="odon.keterangan_tambahan"
                  class="w-100 form-control"
                  placeholder="Keterangan Tambahan"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-md-2">&nbsp;</div>
        <div class="col-md-4 pr-0 pl-3-2">
          <b-button class="mt-3" variant="info" @click="addInputData" :disabled="plusPermukaanKeadaanGigi()">+ Permukaan & Keadaan Gigi</b-button>
        </div>
        <div class="col-md-6 text-right pr-5-0">
          <b-button class="mt-3 mr-3 px-5" variant="danger" @click="closeOdontogram">Batal</b-button>
          <b-button class="mt-3 px-5" variant="primary" @click="saveOdontogram">Simpan</b-button>
        </div>
      </div>
    </b-modal>
    <!-- Modal Odontogram -->
  </div>
</template>
  
<script>;
  import { mapGetters, mapActions, mapState } from 'vuex';
  import debounce from 'lodash/debounce';
  import { toPng } from 'html-to-image';
  import rekamMedisMixin from "../mixins";
  import { library } from '@fortawesome/fontawesome-svg-core';
  import { faChevronDown, faChevronUp, faMinus } from '@fortawesome/free-solid-svg-icons';

  library.add(faChevronDown, faChevronUp, faMinus);
  
  export default {
    name: 'ObjectiveOdontogram',
    mixins: [rekamMedisMixin],
    props: ['ohisErr'],
    components: {
      Editor: () => import('./Editor.vue'),
      Multiselect: () => import('vue-multiselect'),
      'vue-select': () => import('@/components/VueSelectClearable.vue'),
    },
    data() {
      return {
        editData: {},
        isHidden: true,
        isDrawing: false,
        drawing: false,
        mousePos: { x: 0, y: 0 },
        lastPos: { x: 0, y: 0 },
        ctx: null,
        image_url: null,
        isLoading: false,
        isPen: true,
        isActive: null,
        isColorActive: 'black',
        penWidth: 2,
        ediRekamMedis: {},
        imgOdontogram: null,
  
        listConditionGigi: [
          {
            id: null,
            no_gigi: null,
            bagian: null,
            kondisi: null,
            icd_x: [],
            keterangan: null,
            is_blank: true,
          }
        ],
        formOdontogram: {
          occlusi: null,
          diastema: null,
          ket_diastema: null,
          torus_palatinus: null,
          gigi_anomali: null,
          ket_gigi_anomali: null,
          torus_mandibularis: null,
          palatum: null,
          lain_lain: null,
          ket_d: null,
          ket_m: null,
          ket_f: null,
          qty_photo: null,
          satuan_photo: null,
          qty_rontgen: null,
          satuan_rontgen: null,
          muka: null,
          warna_kulit: null,
          bengkak: null,
          suhu_kulit: null,
          konsistensi: null,
          goyang: null,
          perkusi: null,
          warna_gusi: null,
          druk: null,
          karies_gigi: null,
          palpasi: null,
          pembengkakan: null,
          status_karies: null,
        },
        formOHIS: {
          debris_index_16: null,
          debris_index_11: null,
          debris_index_26: null,
          debris_index_36: null,
          debris_index_31: null,
          debris_index_46: null,
          subtotal_debris_index: null,
          count_debris_index: null,
          total_debris_index: null,
          kalkulus_index_16: null,
          kalkulus_index_11: null,
          kalkulus_index_26: null,
          kalkulus_index_36: null,
          kalkulus_index_31: null,
          kalkulus_index_46: null,
          subtotal_kalkulus_index: null,
          count_kalkulus_index: null,
          total_kalkulus_index: null,
          total_ohis: null,
        },
        errOHIS: {
          debris: null,
          kalkulus: null,
        },
        odontogramWidth: 1005,
        odontogramHeight: 500,
        numOdontogram: {
          topBack: [18,17,16,15,14,13,12,11,21,22,23,24,25,26,27,28],
          topFront: [55,54,53,52,51,61,62,63,64,65],
          bottomFront: [85,84,83,82,81,71,72,73,74,75],
          bottomBack: [48,47,46,45,44,43,42,41,31,32,33,34,35,36,37,38],
        },
        posOdon: {
          front: [11,12,13,21,22,23,31,32,33,41,42,43,51,52,53,61,62,63,71,72,73,81,82,83],
          left_top: [11,12,13,14,15,16,17,18,51,52,53,54,55],
          left_bottom: [41,42,43,44,45,46,47,48,81,82,83,84,85],
          right_top: [21,22,23,24,25,26,27,28,61,62,63,64,65],
          right_bottom: [31,32,33,34,35,36,37,38,71,72,73,74,75],
        },
        positions: ['V','M','L','D','O'],
        polygon: {
          lima: {
            V: '0,0 20,0 15,5 5,5',
            M: '15,5 20,0 20,20 15,15',
            L: '5,15 15,15 20,20 0,20',
            D: '0,0 5,5 5,15 0,20',
            O: '5,5 15,5 15,15 5,15',
          },
          empat: {
            V: '0,0 20,0 15,10 5,10',
            M: '15,10 20,0 20,20',
            L: '5,10 15,10 20,20 0,20',
            D: '0,0 5,10 0,20',
          },
          rct: '0,0 10,5 10,15 0,20',
          fmc: '1,0 19,0 19,20 1,20',
          angle_up: '4,0 10,-8 16,0',
          angle_down: '16,20 10,27 4,20',
          arrow_up_left: '-20,-7 15,-7 15,0 15,-7',
          arrow_up_right: '40,-7 5,-7 5,0 5,-7',
          arrow_down_left: '-20,27 15,27 15,20 15,27',
          arrow_down_right: '40,27 5,27 5,20 5,27',
          txt_v: '0,0 3,0 10,14 17,0 20,0 10,20',
          txt_x: '1.5,0 10,8.5 18.5,0 20,1.5 11.5,10 20,18.5 18.5,20 10,11 1.5,20 0,18.5 8.5,10 0,1.5',
        },
        odontogram: [],
        odontogram_notes: null,
  
        option_permukaan_gigi: [],
        option_icd_x: [],
        option_keadaan_gigi: [
          { value: 'sou', label: 'sou - Gigi sehat, normal, tanpa kelainan' },
          { value: 'non', label: 'non - Gigi tidak ada/tidak diketahui' },
          { value: 'une', label: 'une - Un-erupted' },
          { value: 'pre', label: 'pre - Partial erupted' },
          { value: 'imv', label: 'imv - Impacted visible' },
          { value: 'ano', label: 'ano - Anomali' },
          { value: 'dia', label: 'dia - Diastema' },
          { value: 'att', label: 'att - Atrisi' },
          { value: 'abr', label: 'abr - Abrasi' },
          { value: 'car', label: 'car - Caries / karies' },
          { value: 'cfr', label: 'cfr - Crawn fracture/ Fraktur Mahkota' },
          { value: 'nvt', label: 'nvt - Gigi Non Vital' },
          { value: 'rrx', label: 'rrx - Sisa Akar' },
          { value: 'mis', label: 'mis - Gigi Hilang' },
        ],
        option_bahan_restorasi: [
          { value: 'amf', label: 'amf - Amalgam Filing' },
          { value: 'gif', label: 'gif - GIC/Silika' },
          { value: 'cof', label: 'cof - Composite filling' },
          { value: 'fis', label: 'fis - Fissure Sealant' },
        ],
        option_restorasi: [
          { value: 'fmc', label: 'fmc - Full Metal Crown' },
          { value: 'poc', label: 'poc - Porcelain Crown' },
          { value: 'mpc', label: 'mpc - Metal Porcelain Crown' },
          { value: 'gmc', label: 'gmc - Gold Metal Crown' },
          { value: 'rct', label: 'rct - Root Canal Treatment/Perawatan Saluran Akar' },
          { value: 'ipx', label: 'ipx - Implan' },
          { value: 'meb', label: 'meb - Metal Bridge' },
          { value: 'pob', label: 'pob - Porcelain Bridge' },
          { value: 'pon', label: 'pon - Pontic' },
          { value: 'abu', label: 'abu - Gigi abutment' },
          { value: 'inl', label: 'inl - Inlay' },
          { value: 'onl', label: 'onl - Onlay' },
        ],
        option_protesa: [
          { value: 'prd', label: 'prd - Partial Denture' },
          { value: 'fld', label: 'fld - Full Denture' },
          { value: 'acr', label: 'acr - Acrilic' },
        ],
  
        tmpInputData: [],
        simbolOdontogram: {
          data: [],
          page: 1,
          limit: 7,
          last_page: null,
          col_left: 3,
          col_right: 9,
        },
        contentWidth: 1410,
        icon: {
          division: `
            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 20 20" fill="none">
              <path d="M5 11C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H5Z" fill="#000000"/>
              <circle cx="10" cy="5.5" r="1.5" fill="#000000"/>
              <circle cx="10" cy="14.5" r="1.5" fill="#000000"/>
            </svg>
          `,
          plus: '+',
          equals: '=',
        },
      };
    },
    computed: {
      ...mapState(['sidebar']),
      ...mapGetters('sidebar', ['collapsed', 'collapsedMobile', 'orientation']),
      ...mapGetters([
        'getKlinikId',
        'kesadaran',
        'saving_params',
      ]),
      canvas: function() {
        return this.$refs.canvas;
      },
      fieldListGigi() {
        return (
          [
            {
              key: 'no_gigi',
              label: 'no gigi',
              thClass: 'head-custom-odon text-subtitle',
              stickyColumn: true,
              isRowHeader: true,
            },
            {
              key: 'bagian',
              label: 'bagian',
              thClass: 'head-custom-odon text-subtitle',
            },
            {
              key: 'kondisi',
              label: 'kondisi',
              thClass: 'head-custom-odon text-subtitle',
            },
            {
              key: 'icdx',
              label: 'icd 10',
              thClass: 'head-custom-odon text-subtitle',
            },
            {
              key: 'keterangan',
              label: 'keterangan tambahan',
              thClass: 'head-custom-odon text-subtitle',
            },
          ]
        )
      },
    },
    watch: {
      imgOdontogram: function() {
        if (this.checkValueData(this.imgOdontogram)) this.drawChanged();
      },
      collapsed() {
        setTimeout(() => {
          this.resizeWidth(window.innerWidth, this.collapsed);
        }, 500);
      },
      collapsedMobile() {
        setTimeout(() => {
          this.resizeWidth(window.innerWidth, this.collapsedMobile);
        }, 500);
      },
      orientation() {
        setTimeout(() => {
          this.resizeWidth(window.innerWidth, this.collapsedMobile);
        }, 500);
      },
      ohisErr() {
        this.errOHIS.debris = this.errOHIS.kalkulus = null;
        
        if (this.ohisErr && this.ohisErr.debris.length > 0) {
          const errDebris = this.ohisErr.debris.join(',');
          if (errDebris.includes('over_limit')) this.errOHIS.debris = 'inputan hanya boleh terdiri dari angka 1, 2 dan 3.';
        }

        if (this.ohisErr && this.ohisErr.kalkulus.length > 0) {
          const errKalkulus = this.ohisErr.kalkulus.join(',');
          if (errKalkulus.includes('over_limit')) this.errOHIS.kalkulus = 'inputan hanya boleh terdiri dari angka 1, 2 dan 3.';
        }
      },
    },
    methods: {
      ...mapActions(['updatePostData', 'updateCanvas', 'updateKesadaran']),
      resizeWidth(w, collapsed = false) {
        let x = 1.415;

        let zoom = w / 19.2;
        if (collapsed) {
          if (zoom < 100) {
            if (this.orientation == 'portrait') x = 1.25;
            else x = 1.525;
          } else x = 1.2;
        } else if (zoom < 100) {
          if (this.orientation == 'portrait') x = 1.9;
          else x = 1.7;
        }
          
        this.canvasWidth = this.contentWidth = w / x;
      },
      updateContent(content) {
        this.updatePostData({ key: 'odontogram_text', value: content });
      },
      inputOnlyNumber($event) {
        const { key } = $event;
        var evt = $event;
        evt = evt ? evt : window.event;
        if (/[^0-9]/.test(key)) {
          evt.preventDefault();
        }
      },
      inputOnlyNumberSpecial($event) {
        const { key } = $event;
        var evt = $event;
        evt = evt ? evt : window.event;
        if (/[^0-9.,]/.test(key)) {
          evt.preventDefault();
        }
      },
      setOdontogramData(d) {
        if (d.odontogram) {
          this.editData = d.odontogram;
          if (this.checkValueData(d.odontogram.notes)) {
            this.isActive = 'keyboard';
            this.odontogram_notes = d.odontogram.notes
          }
          this.imgOdontogram = this.checkValueData(d.draw_path) ? d.draw_path : null;
  
          Object.keys(this.formOdontogram).forEach(fo => {
            let label = fo;
            if (['ket_d','ket_m','ket_f'].includes(fo)) label = fo.replace('ket_', '');
  
            if (this.editData.hasOwnProperty(label)) {
              let val = this.editData[label];
              if (fo.includes('qty_') && val == 0) val = null;
              
              this.formOdontogram[fo] = val;
              this.setValue({ label: fo, $event: val });
            }
          });
  
          if (this.editData.ohis) {
            const ohis = this.editData.ohis;
            Object.keys(this.formOHIS).forEach(label => {
              if (ohis.hasOwnProperty(label)) {
                let val = ohis[label];
                this.formOHIS[label] = val;
                this.setValueOHIS({ label: label, $event: val });
              }
            });
          }
        }
      },
      drawChanged() {
        // get the image URL
        let self = this;
        self.image_url = this.imgOdontogram;
        self.clear();
        self.drawBackground(self.image_url);
        this.updatePostData({ key: 'odontogram_is_draw', value: true });
      },
      // draw the image
      drawBackground(image_url) {
        let self = this;
        let canvas = document.getElementById('odontogram-canvas'),
          ctx = canvas.getContext('2d');
  
        let img = new Image();
        img.crossOrigin = 'odontogram';
        img.src = image_url;
  
        img.onload = function() {
          let newSize = { width: img.width, height: img.height };
          if (img.width > 700) {
            newSize = self.resizeImage(img);
          }
          ctx.drawImage(img, 0, 0, newSize.width, newSize.height);
        };
        this.isDrawing = true;
      },
      resizeImage(background) {
        let width = background.width,
          height = background.height,
          screen_width = screen.width;
  
        if (screen_width > 1366) width = 0.53 * screen_width;
        else width = 0.75 * screen_width;
        height = height * (width / background.width); // 0.5 * height;
        return { width, height };
      },
      handleMousedown(e) {
        this.lastPos = this.getMousePos(e);
        this.ctx.lineWidth = this.penWidth;
        this.drawing = true;
      },
      handleMouseup(e) {
        this.drawing = false;
      },
      handleMousemove(e) {
        this.mousePos = this.getMousePos(e);
        if (this.drawing) {
          this.ctx.beginPath();
          if (this.isPen) {
            this.ctx.globalCompositeOperation = 'source-over';
            this.ctx.moveTo(this.lastPos.x, this.lastPos.y);
            this.ctx.lineTo(this.mousePos.x, this.mousePos.y);
            this.ctx.stroke();
          } else {
            this.ctx.globalCompositeOperation = 'destination-out';
            this.ctx.arc(
              this.mousePos.x,
              this.mousePos.y,
              this.penWidth,
              0,
              Math.PI * 2,
              false
            );
            this.ctx.fill();
          }
          this.lastPos = this.mousePos;
        }
      },
      handleTouchstart(event) {
        this.mousePos = this.getTouchPos(event);
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousedown', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchend(event) {
        let mouseEvent = new MouseEvent('mouseup', {});
        this.canvas.dispatchEvent(mouseEvent);
      },
      handleTouchmove(event) {
        let touch = event.touches[0];
        let mouseEvent = new MouseEvent('mousemove', {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        this.canvas.dispatchEvent(mouseEvent);
      },
      getMousePos(mouseEvent) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: mouseEvent.clientX - rect.left,
          y: mouseEvent.clientY - rect.top
        };
      },
      // Get the position of a touch relative to the canvas
      getTouchPos(touchEvent) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: touchEvent.touches[0].clientX - rect.left,
          y: touchEvent.touches[0].clientY - rect.top
        };
      },
      penColor(color) {
        this.ispen = true;
        this.ctx.strokeStyle = color;
      },
      clear() {
        this.canvas.width = this.canvas.width;
      },
      setDrawPostData(type) {
        if (type == 'pen') {
          this.isPen = true;
          this.isHidden = false;
          this.isDrawing = true;
        } else if (type == 'eraser') {
          this.isPen = false;
          this.isHidden = false;
        } else {
          this.isPen = false;
          this.isHidden = true;
        }
  
        if (this.isActive == 'keyboard') this.isActive = null;
        else this.isActive = 'keyboard';
      },
      modalSimbolOdontogram() {
        this.$refs['simbol-odontogram'].show();
      },
      modalOdontogram(num, pos) {
        let odon = this.listConditionGigi.filter(l => l.no_gigi == num);
        if (odon.length > 0) {
          let tmp = [];
          odon.forEach((v, i) => {
            tmp[i] = this.defaultTmpInputData()[0];
  
            tmp[i].id = v.id || null;
            tmp[i].no = num;
            tmp[i].permukaan_gigi = this.option_permukaan_gigi.find(pg => pg.value == v.permukaan_gigi);
            tmp[i].odontogram = this.defaultOdontogram(num);
          });
          this.tmpInputData = tmp;
          this.tmpInputData.forEach((v, i) => {
            this.setKondisiOdon(i, v);
            this.simbolOdontogramModal(i);
          });
        } else {
          this.tmpInputData = this.defaultTmpInputData();
  
          this.tmpInputData[0].no = num;
          this.tmpInputData[0].permukaan_gigi = this.option_permukaan_gigi.find(pg => pg.value == pos);
  
          let positions = this.listConditionGigi.filter(l => l.no_gigi == num).map(v => v.permukaan_gigi);
          if (positions.includes(pos)) this.tmpInputData[0].odontogram = this.findOdontogram(num);
          else this.tmpInputData[0].odontogram = this.defaultOdontogram(num);
        }
  
        if (this.posOdon.front.includes(num)) {
          this.option_permukaan_gigi = this.option_permukaan_gigi.filter(pg => pg.value != 'O');
        } else {
          this.option_permukaan_gigi = this.defaultPermukaanGigi();
        }      
        this.$refs['modal-odontogram'].show();
      },
      closeOdontogram() {
        this.tmpInputData = this.defaultTmpInputData();
        this.option_permukaan_gigi = this.defaultPermukaanGigi();
        this.$refs['modal-odontogram'].hide();
      },
      plusPermukaanKeadaanGigi() {
        if (this.tmpInputData.length > 3) return true;
        else if (this.tmpInputData.find(tmp => (tmp.permukaan_gigi && tmp.permukaan_gigi.value) == 'all')) return true;
        return false;
      },
      removeInputData(idx) {
        const { tmpInputData } = this;
        if (tmpInputData.length > 1) {
          const tmp = tmpInputData
            .slice(0, idx)
            .concat(tmpInputData.slice(idx + 1, tmpInputData.length));
          this.tmpInputData = tmp;
          this.checkPermukaanGigi();
        }
      },
      addInputData() {
        let defaultOdontogram = this.defaultTmpInputData();
        let num = this.tmpInputData[0].no;
        defaultOdontogram[0].no = num;
        defaultOdontogram[0].odontogram = this.defaultOdontogram(num);
        this.tmpInputData = [...this.tmpInputData, ...defaultOdontogram];
        this.checkPermukaanGigi();
      },
      selectedOdontogram(idx, pos) {
        if (pos == 'all') {
          let tmp = this.tmpInputData[idx];
          this.tmpInputData = this.defaultTmpInputData();
          this.tmpInputData[0] = tmp;
          this.tmpInputData[0].permukaan_gigi = this.option_permukaan_gigi.find(pg => pg.value == pos);
  
          let positions = this.listConditionGigi.filter(l => l.no_gigi == tmp.no_gigi).map(v => v.permukaan_gigi);
          if (positions.includes('all')) this.tmpInputData[0].odontogram = this.findOdontogram(tmp.no_gigi);
          else this.tmpInputData[0].odontogram = this.defaultOdontogram(tmp.no);
  
          this.checkPermukaanGigi();
          this.simbolOdontogramModal(0);
        } else {
          this.tmpInputData[idx].permukaan_gigi = this.option_permukaan_gigi.find(pg => pg.value == pos);
          this.checkPermukaanGigi();
          this.simbolOdontogramModal(idx);
        }
      },
      setValue({ label, $event = null }) {
        let value = $event;
        if (['diastema','gigi_anomali'].includes(label) && this.editData) {
          let lbl = 'ket_' + label;
          if (value == 'Ada') {
            this.formOdontogram[lbl] = this.editData[lbl];
            this.updatePostData({ key: lbl, value: this.editData[lbl] });
          } else {
            this.formOdontogram[lbl] = null;
            this.updatePostData({ key: lbl, value: null });
          }
        }
        this.updatePostData({ key: label, value: value });
      },
      setValueOHIS({ label, $event = null }) {
        let status = [];
        this.formOHIS[label] = this.checkValueData($event) ?  $event.toString().replace(/^0+(?!$)/, '') : $event;
        let value = parseInt(this.formOHIS[label]);
        this.updatePostData({ key: label, value: isNaN(value) ? null : value });
        
        // calculate debris
        if (label.includes('debris')) {
          let errDebris = [];
          this.errOHIS.debris = null;
          
          this.formOHIS.count_debris_index = 0;
          this.formOHIS.subtotal_debris_index = 0;

          ['debris_index_16','debris_index_11','debris_index_26','debris_index_36','debris_index_31','debris_index_46'].forEach(d => {
            let v = parseInt(this.formOHIS[d]);
            if (v != null && v != undefined && !isNaN(v)) {
              if (v > 3 || v < 1) errDebris.push(true);
              else document.getElementById(d).classList.remove('invalid');

              this.formOHIS.count_debris_index++;
              this.formOHIS.subtotal_debris_index += v;
            }
          });
          if (errDebris.length > 0) {
            status.push(false);
            this.errOHIS.debris = 'inputan hanya boleh terdiri dari angka 1, 2 dan 3.';
            return;
          }
          if (this.formOHIS.count_debris_index > 0) {
            let totalDebris = (this.formOHIS.subtotal_debris_index / this.formOHIS.count_debris_index).toFixed(1);
            this.formOHIS.total_debris_index = totalDebris.endsWith('.0') ? Math.floor(totalDebris) : totalDebris;
          } else if (this.formOHIS.count_debris_index == 0) {
            this.formOHIS.total_debris_index = 0;
          }
          this.updatePostData({ key: 'subtotal_debris_index', value: this.formOHIS.subtotal_debris_index });
          this.updatePostData({ key: 'count_debris_index', value: this.formOHIS.count_debris_index });
          this.updatePostData({ key: 'total_debris_index', value: this.formOHIS.total_debris_index });
        }
        
        // calculate kalkulus
        if (label.includes('kalkulus')) {
          let errKalkulus = [];
          this.errOHIS.kalkulus = null;

          this.formOHIS.count_kalkulus_index = 0;
          this.formOHIS.subtotal_kalkulus_index = 0;

          ['kalkulus_index_16','kalkulus_index_11','kalkulus_index_26','kalkulus_index_36','kalkulus_index_31','kalkulus_index_46'].forEach(k => {
            let v = parseInt(this.formOHIS[k]);
            if (v != null && v != undefined && !isNaN(v)) {
              if (v > 3 || v < 1) errKalkulus.push(true);
              else document.getElementById(k).classList.remove('invalid');

              this.formOHIS.count_kalkulus_index++;
              this.formOHIS.subtotal_kalkulus_index += v;
            }
          });
          if (errKalkulus.length > 0) {
            status.push(false);
            this.errOHIS.kalkulus = 'inputan hanya boleh terdiri dari angka 1, 2 dan 3.';
            return;
          }
          if (this.formOHIS.count_kalkulus_index > 0) {
            let totalKalkulus = (this.formOHIS.subtotal_kalkulus_index / this.formOHIS.count_kalkulus_index).toFixed(1);
            this.formOHIS.total_kalkulus_index = totalKalkulus.endsWith('.0') ? Math.floor(totalKalkulus) : totalKalkulus;
          } else if (this.formOHIS.count_kalkulus_index == 0) {
            this.formOHIS.total_kalkulus_index = 0;
          }
          this.updatePostData({ key: 'subtotal_kalkulus_index', value: this.formOHIS.subtotal_kalkulus_index });
          this.updatePostData({ key: 'count_kalkulus_index', value: this.formOHIS.count_kalkulus_index });
          this.updatePostData({ key: 'total_kalkulus_index', value: this.formOHIS.total_kalkulus_index });
        }

        if (status.length > 0) return;

        if (this.formOHIS.total_debris_index || this.formOHIS.total_kalkulus_index) {
          let totalDebrisIndex = parseFloat(this.formOHIS.total_debris_index);
          let totalKalkulusIndex = parseFloat(this.formOHIS.total_kalkulus_index);
          let totalOHIS = ((isNaN(totalDebrisIndex) ? 0 : totalDebrisIndex) + (isNaN(totalKalkulusIndex) ? 0 : totalKalkulusIndex)).toFixed(1);
          this.formOHIS.total_ohis = totalOHIS.endsWith('.0') ? Math.floor(totalOHIS) : totalOHIS;
          this.updatePostData({ key: 'total_ohis', value: this.formOHIS.total_ohis });
        } else {
          this.formOHIS.total_ohis = 0;
          this.updatePostData({ key: 'total_ohis', value: this.formOHIS.total_ohis });
        }
      },
      setValueModal({ idx, label, $event = null }) {
        if (label == 'permukaan_gigi') {
          this.tmpInputData[idx][label] = $event;
  
          if ($event && $event.value == 'all') {
            let tmp = this.tmpInputData[idx];
            this.tmpInputData = this.defaultTmpInputData();
            this.tmpInputData[0] = tmp;
  
            let positions = this.listConditionGigi.filter(l => l.no_gigi == tmp.no_gigi).map(v => v.permukaan_gigi);
            if (positions.includes('all')) this.tmpInputData[0].odontogram = this.findOdontogram(tmp.no_gigi);
            else this.tmpInputData[0].odontogram = this.defaultOdontogram(tmp.no);
  
            this.checkPermukaanGigi();
            this.simbolOdontogramModal(0);
          } else {
            this.checkPermukaanGigi();
            this.simbolOdontogramModal(idx);
          }
        }
  
        if (['keadaan_gigi','bahan_restorasi','restorasi','protesa'].includes(label)) {
          if ($event.length > 0 && $event.find(e => ['mis','pon','meb','pob','abu','cfr','rrx'].includes(e.value))) {
            this.setValueModal({ idx, label: 'permukaan_gigi', $event: this.option_permukaan_gigi.find(pg => pg.value == 'all') });
          } else if ($event.length > 0 && this.checkSelectedPermukaanGigi(idx, label)) this.tmpInputData[idx][label] = [];
          this.simbolOdontogramModal(idx);
        }
      },
      setKondisiOdon(idx, val) {
        let data = this.listConditionGigi.find(l => l.permukaan_gigi == (val.permukaan_gigi && val.permukaan_gigi.value) && l.no_gigi == val.no);
        if (data) {
          this.tmpInputData[idx].keadaan_gigi = this.option_keadaan_gigi.filter(kg => data.keadaan_gigi.includes(kg.value));
          this.tmpInputData[idx].bahan_restorasi = this.option_bahan_restorasi.filter(br => data.bahan_restorasi.includes(br.value));
          this.tmpInputData[idx].restorasi = this.option_restorasi.filter(r => data.restorasi.includes(r.value));
          this.tmpInputData[idx].protesa = this.option_protesa.filter(p => data.protesa.includes(p.value));
          this.tmpInputData[idx].icd_x = data.icd_x.map(icd => ({ ...icd, description: `${icd.kode} - ${icd.description}`}));
          this.tmpInputData[idx].keterangan_tambahan = data.keterangan;
        } else {
          this.tmpInputData[idx].keadaan_gigi = [];
          this.tmpInputData[idx].bahan_restorasi = [];
          this.tmpInputData[idx].restorasi = [];
          this.tmpInputData[idx].protesa = [];
          this.tmpInputData[idx].icd_x = [];
          this.tmpInputData[idx].keterangan_tambahan = null;
        }
      },
      checkSelectedPermukaanGigi(idx, label) {
        if (label == 'permukaan_gigi') return false;
  
        let tmp = this.tmpInputData[idx];
        if (tmp && !this.checkValueData(tmp.permukaan_gigi)) {
          this.$swal({
            html: `Silakan pilih Permukaan Gigi terlebih dahulu!`,
            type: 'warning',
            showCancelButton: false,
            confirmButtonText: 'Ya',
          });
          return true;
        }
        return false;
      },
      async deleteKondisiGigi(data) {
        this.$swal({
          html: `
            <p>Apakah Anda yakin akan menghapus:</p>
            <p class="m-0">No Gigi: ${data.no_gigi} | Bagian: ${data.bagian}</p>
            <p class="m-0">Kondisi: ${data.kondisi}</p>
          `,
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Ya',
        }).then(async res => {
          if (res.value) {
            await this.deleteOdontogramTable(data);
          }
        });
      },
      async clearOdontogram(data) {
        this.$swal({
          html: `
            <p>Apakah Anda yakin akan melakukan clear data Odontogram?</p>`,
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Ya',
        }).then(async res => {
          if (res.value) {
            await this.clearOdontogramTable(data);
          }
        });
      },
      patchStyleSheets() {
        const original = Array.from(document.styleSheets);
        original.forEach((sheet, i) => {
          if (!sheet._patched) {
            try {
              void sheet.cssRules;
            } catch (e) {
              Object.defineProperty(sheet, 'cssRules', {
                get: () => [],
              });
            }
            sheet._patched = true;
          }
        });
      },
      async convertOdontogramToImage() {
        const svg = this.$refs.svg_odontogram;

        this.patchStyleSheets();
        if (svg && svg != undefined) {
          const options = {
            quality: 0.19,
            pixelRatio: 1.3,
            backgroundColor: 'transparent',
            skipAutoScale: true,
            type: 'image/png',
            allowTaint: true,
            useCORS: true,
            cacheBust: true,
            filter: (node) => {
              if (node.tagName === 'LINK' || node.tagName === 'STYLE') {
                return false;
              }
              return true;
            }
          }
          let img = await toPng(svg, options);
          if (this.checkValueData(img) && img != 'data:,') this.imgOdontogram = img;
          else if (this.checkValueData(this.editData.draw_path)) this.imgOdontogram = this.editData.draw_path;
        }
      },
      mouseenter(num, pos) {
        let f = this.odontogram[num].find(o => o.position == pos);
        if (f) {
          f.defaultClass = f.class;
          f.class = `${pos} fill-ccc`;
        }
      },
      mouseleave(num, pos) {
        let f = this.odontogram[num].find(o => o.position == pos);
        if (f) f.class = f.defaultClass || f.class;
      },
      findOdontogram(num) {
        return this.odontogram[num];
      },
      setDataOdontogram() {
        let data = [];
        Object.keys(this.numOdontogram).forEach(n => {
          this.numOdontogram[n].forEach(v => {
            data[v] = [];
            let cpo = this.checkPositionOdon(v);
            this.positions.forEach(p => {
              let pos = p;
              if (cpo.includes('bottom')) {
                if (p == 'V') pos = 'L';
                else if (p == 'L') pos = 'V';
              }
              if (cpo.includes('right')) {
                if (p == 'M') pos = 'D';
                else if (p == 'D') pos = 'M';              
              }
  
              let points = this.pointsSimbolOdon(v, p);
              if (points && points != undefined) {
                let cls = this.classSimbolOdon(pos, pos);
                data[v].push({
                  no: v,
                  position: pos,
                  class: cls,
                  defaultClass: cls,
                  points: points,
                  stroke: '#515151',
                  stroke_width: '0.2',
                  opacity: 1,
                });
              }
            });
          });
        });
        this.odontogram = data;
      },
      checkPositionOdon(num) {
        let result = null;
        Object.keys(this.posOdon)
        .forEach(n => {
          if (n == 'front' || result) return;
          if (this.posOdon[n].includes(num)) result = n;
        });
        return result;
      },
      getPositionOdon(pos = 'top') {
        let result = [];
        Object.keys(this.posOdon).forEach(po => {
          if (po.includes(pos)) result = [...result, ...this.posOdon[po]];
        });
        return result;
      },
      debounceICDX: debounce(function(val) {
        this.asyncFindICDX(val);
      }, 500),
      asyncFindICDX(query = '') {
        let self = this;
        this.isLoading = true;
  
        if (this.saving_params.is_bpjs) {
          this.$axios.get(`bpjs/diagnosa?klinik_id=${this.getKlinikId}&kode=${query}&first_row=0&limit=100`)
          .then(res => {
            const { metaData, response } = res.data;
  
            if (metaData.code != 200) {
              self.isLoading = false;
              return;
            }
            const kode_penyakit = response.list.map(item => ({
              id: item.kdDiag,
              kode: item.kdDiag,
              description: item.kdDiag + ' - ' + item.nmDiag,
              nonSpesialis: item.nonSpesialis,
            }));
            if (kode_penyakit.length > 0) {
              self.option_icd_x = kode_penyakit;
            }
            self.isLoading = false;
          })
          .catch(err => {
            self.isLoading = false;
          });
        } else {
          this.$axios
          .get(`kode_penyakit?name=${query}`)
          .then(response => {
            let res = response.data;
  
            if (!res.status) {
              self.isLoading = false;
              return;
            }
            let kode_penyakit = res.data.kode_penyakit.data;
            if (kode_penyakit) {
              self.option_icd_x = kode_penyakit.map(kp => {
                return {
                  ...kp,
                  description: kp.kode + ' - ' + kp.description,
                }
              });
            }
            self.isLoading = false;
          })
          .catch(err => {
            self.isLoading = false;
          });
        }
      },
      limitText(count) {
        return `and ${count} other kode penyakit`;
      },
      generateError() {
        return {
          error: null,
          desc: null,
        };
      },
      errorState({ label, index }) {
        const { tmpInputData } = this;
        if (
          tmpInputData[index].errors &&
          tmpInputData[index].errors[label]
        ) return tmpInputData[index].errors[label].error;
        
        return null;
      },
      defaultOdontogram(num) {
        let data = [], cpo = this.checkPositionOdon(num);
        this.positions.forEach(p => {
          let pos = p;
          if (cpo.includes('bottom')) {
            if (p == 'V') pos = 'L';
            else if (p == 'L') pos = 'V';
          }
          if (cpo.includes('right')) {
            if (p == 'M') pos = 'D';
            else if (p == 'D') pos = 'M';              
          }
  
          let points = this.pointsSimbolOdon(num, p);
          if (points && points != undefined) {
            let cls = this.classSimbolOdon(pos, pos);
            data.push({
              no: num,
              position: pos,
              class: cls,
              defaultClass: cls,
              points: points,
              stroke: '#515151',
              stroke_width: '0.2',
              opacity: 1,
            });
          }
        });
        return data;
      },
      defaultTmpInputData() {
        let odon = [{
          id: null,
          no: null,
          disabled: false,
          odontogram: null,
          permukaan_gigi: null,
          keadaan_gigi: [],
          bahan_restorasi: [],
          restorasi: [],
          protesa: [],
          icd_x: [],
          keterangan_tambahan: null,
          errors: {
            permukaan_gigi: null,
          }
        }];
  
        return odon.map(item => {
          const tmp = Object.keys(item).reduce((obj, key) => {
            if (!['disabled','no'].includes(key)) obj[key] = this.generateError();
            return obj;
          }, {});
  
          return {
            ...item,
            errors: tmp
          };
        });
      },
      defaultPermukaanGigi() {
        return [
          { value: 'all', label: 'Semua' },
          { value: 'M', label: 'M - Messial' },
          { value: 'O', label: 'O - Occlusal' },
          { value: 'D', label: 'D - Distal' },
          { value: 'V', label: 'V - Vestibular/Bukal/Labial' },
          { value: 'L', label: 'L - Lingual/Palatal' },
        ];
      },
      checkPermukaanGigi() {
        if (this.tmpInputData.length == 1) {
          this.tmpInputData[0].errors['permukaan_gigi'].error = true;
          this.tmpInputData[0].errors['permukaan_gigi'].desc = '';
          return;
        }
        this.tmpInputData.forEach((item1, i) => {
          let isDuplicate = false;
          this.tmpInputData.forEach((item2, j) => {
            if (i == j) return;
  
            if (item1.permukaan_gigi && item2.permukaan_gigi) {
              if (item1.permukaan_gigi.value == item2.permukaan_gigi.value) {
                this.tmpInputData[i].errors['permukaan_gigi'].error = false;
                this.tmpInputData[i].errors['permukaan_gigi'].desc = 'Permukaan Gigi tidak boleh sama';
                isDuplicate = true;
              }
            }
          });
          if (!isDuplicate) {
            this.tmpInputData[i].errors['permukaan_gigi'].error = true;
            this.tmpInputData[i].errors['permukaan_gigi'].desc = '';
          }
        });
      },
      async saveOdontogram() {
        const { checkPermukaanGigi, tmpInputData } = this;
        checkPermukaanGigi();
  
        let cpg = false, check = false, permukaan_gigi = null;
        tmpInputData.forEach(tmp => {
          if (check || cpg) return;
  
          if (!tmp.errors['permukaan_gigi'].error) cpg = true;
          if (tmp.keadaan_gigi.length == 0 && tmp.bahan_restorasi.length == 0 && tmp.restorasi.length == 0 && tmp.protesa.length == 0) {
            permukaan_gigi = tmp.permukaan_gigi.label;
            check = true;
          }
        });
        if (cpg) return;
  
        if (check) {
          this.$swal({
            title: `Permukaan Gigi: ${permukaan_gigi}`,
            html: `
              Oops..! Ada kolom yang belum terisi!
              <br>Lengkapi salah satu kolom (keadaan gigi, bahan restorasi, restorasi atau protesa) sebelum menyimpan data!
            `,
            type: 'warning',
            showCancelButton: false,
            confirmButtonText: 'Ya',
          });
          return;
        }
  
        const formData = tmpInputData.map(tmp => {
          return {
            id: tmp.id,
            no_gigi: tmp.no,
            permukaan_gigi: tmp.permukaan_gigi && tmp.permukaan_gigi.value,
            keadaan_gigi: tmp.keadaan_gigi.map(kg => kg.value),
            bahan_restorasi: tmp.bahan_restorasi.map(br => br.value),
            restorasi: tmp.restorasi.map(r => r.value),
            protesa: tmp.protesa.map(p => p.value),
            icd_x: tmp.icd_x,
            keterangan_tambahan: tmp.keterangan_tambahan,
          }
        });
        const res = await this.$axios.post(`odontogram/store`, {
          transklinik_id: this.$router.currentRoute.params.transklinik_id,
          klinik_id: this.getKlinikId,
          table: formData,
        });
        const { status, message } = res.data;
  
        if (status) {
          this.$refs['modal-odontogram'].hide();
          this.$swal({
            html: `Data Berhasil disimpan`,
            type: 'success',
            showCancelButton: false,
            confirmButtonText: 'Ya',
          });
          await this.fetchOdontogramTable();
          return;
        }
  
        this.$swal({
          html: message,
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Ya',
        });
      },
      async deleteOdontogramTable(data) {
        try {
          const res = await this.$axios.delete(`odontogram/table/delete/${data.id}`);
          const { status, message } = res.data;
  
          if (status) {
            this.$swal({
              html: `Data Berhasil dihapus`,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'Ya',
            });
            await this.fetchOdontogramTable(data.no_gigi);
            return;
          }
  
          this.$swal({
            html: message,
            type: 'warning',
            showCancelButton: false,
            confirmButtonText: 'Ya',
          });
        } catch (err) {}
      },
      async clearOdontogramTable() {
        try {
          const res = await this.$axios.post(`odontogram/table/clear`, {
            transklinik_id: this.$router.currentRoute.params.transklinik_id,
            klinik_id: this.getKlinikId,
          });
          const { status, message } = res.data;
  
          if (status) {
            this.$swal({
              html: `Data Berhasil diclear`,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'Ya',
            });
            Object.keys(this.formOdontogram)
            .forEach(label => {
              if (!['torus_palatinus','gigi_anomali','ket_gigi_anomali','torus_mandibularis','palatum'].includes(label)) {
                this.formOdontogram[label] = null;
                this.setValue({ label: label, $event: null });
              }
            });
            await this.fetchOdontogramTable();
            return;
          }
  
          this.$swal({
            html: message,
            type: 'warning',
            showCancelButton: false,
            confirmButtonText: 'Ya',
          });
        } catch (err) {}
      },
      async fetchOdontogramTable(no_gigi = 0) {
        try {
          const res = await this.$axios.get(`odontogram/table?klinik_id=${this.getKlinikId}&transklinik_id=${this.$router.currentRoute.params.transklinik_id}`);
          const { status, data } = res.data;
  
          if (status) {
            this.listConditionGigi = data.map(d => {
              let pg = this.defaultPermukaanGigi().find(pg => pg.value == d.permukaan_gigi);
              return {
                ...d,
                bagian: pg ? pg.label : '-',
                kondisi: this.setKondisi(d),
                icdx: d.icd_x.length > 0 ? d.icd_x.map(icd => `${icd.kode} - ${icd.description}`): '-',
                is_blank: false,
              }
            });
            this.$emit('icdxOdontogramCheck', data.filter(d => d.icd_x.length > 0).length > 0);
            this.updatePostData({ key: 'odontogram_icdx', value: data.filter(d => d.icd_x.length > 0).map(d => d.icd_x) });
            this.simbolOdontogramLayout(data, no_gigi);
          }
        } catch (err) {}
      },
      setKondisi(data) {
        let kondisi = [];
        if (data.keadaan_gigi.length > 0) kondisi = [...kondisi, ...data.keadaan_gigi];
        if (data.bahan_restorasi.length > 0) kondisi = [...kondisi, ...data.bahan_restorasi];
        if (data.restorasi.length > 0) kondisi = [...kondisi, ...data.restorasi];
        if (data.protesa.length > 0) kondisi = [...kondisi, ...data.protesa];
        return kondisi.length > 0 ? kondisi.join(' - ') : '-';
      },
      async fetchSimbolOdontogram() {
        try {
          const res = await this.$axios.get(`odontogram/simbol?limit=${this.simbolOdontogram.limit}&page=${this.simbolOdontogram.page}`);
          const { status, data } = res.data;
  
          if (status) {
            let no = 1;
            let dataSimbol = data.data.map(d => {
              let odon = [];
              JSON.parse(d.dental).forEach((dnt, idx) => {
                let odo = [];
                let num = dnt.polygon == 4 ? 11 : 18;
                ['cof','poc','pob','fis','gif'].forEach(arsir => {
                  if (d.code.includes(arsir)) {
                    if (
                      (d.code == 'cof' && idx == 1)
                      || (d.code == 'cof - rct' && dnt.polygon == 4)
                    ) {
                      arsir = 'pob';
                    }
                    let arsir_adtl = this.additionalSimbolOdon(num, 'x-' + arsir, 'arsir-' + arsir);
                    if (arsir_adtl && arsir_adtl != undefined) odo.push(arsir_adtl);
                  }
                });
  
                this.positions.forEach(p => {
                  let points = this.pointsSimbolOdon(num, p);
                  if (points && points != undefined) {
                    let cls = this.classSimbolOdon(d.code, p, dnt.position);
                    odo.push({
                      no: no++,
                      position: p,
                      class: cls,
                      defaultClass: cls,
                      points: points,
                      stroke: '#515151',
                      stroke_width: '0.2',
                      opacity: 1,
                    });
                  }
                });
  
                let c = d.code.split(' - ');
                let not = d.code == 'cof - rct' && dnt.polygon == 5;
                if (c.length > 0 && !not) {
                  for (let i in c) {
                    let additional = this.additionalSimbolOdon(num, 'x-' + i, ['fmc','poc'].includes(c[i]) ? 'border' : c[i]);
                    if (additional && additional != undefined) odo.push(additional);
                  }
                }
                if ((d.code == 'pob' && [1,2].includes(idx)) || (d.code == 'meb - pon' && idx == 1) || (d.code == 'meb' && idx == 2)) {
                  let adt = this.additionalSimbolOdon(num, 'x-mis-' + idx, 'mis');
                  if (adt && adt != undefined) odo.push(adt);
                }
                if (d.code == 'prd/fld') {
                  let adtl = this.additionalSimbolOdon(num, 'txt-idx', 'txt-prd/fld');
                  if (adtl && adtl != undefined) odo.push(adtl);
                }
                if ((d.code == 'meb - pon' && idx == 0) || (d.code == 'meb' && idx == 1) || (d.code == 'pob' && idx == 0)) {
                  let adtlLeft = this.additionalSimbolOdon(18, 'x-arrow-right-' + idx, 'arrow-right', false);
                  if (adtlLeft && adtlLeft != undefined) odo.push(adtlLeft);
                }
                if ((d.code == 'meb - pon' && idx == 2) || (d.code == 'pob' && idx == 3)) {
                  let adtlRight = this.additionalSimbolOdon(18, 'x-arrow-left-' + idx, 'arrow-left', false);
                  if (adtlRight && adtlRight != undefined) odo.push(adtlRight);
                }
                if (d.code == 'mvr') {
                  if (idx == 0) {
                    let adtl = this.additionalSimbolOdon(11, 'x-arsir-l-' + idx, 'arsir-l', false);
                    if (adtl && adtl != undefined) odo.push(adtl);
                  }
                  if (idx == 1) {
                    let adtr = this.additionalSimbolOdon(11, 'x-arsir-r-' + idx, 'arsir-r', false);
                    if (adtr && adtr != undefined) odo.push(adtr);
                  }
                  if (idx == 2) {
                    let adtt = this.additionalSimbolOdon(11, 'x-arsir-t-' + idx, 'arsir-t', false);
                    if (adtt && adtt != undefined) odo.push(adtt);
                  }
                  if (idx == 3) {
                    let adtb = this.additionalSimbolOdon(11, 'x-arsir-b-' + idx, 'arsir-b', false);
                    if (adtb && adtb != undefined) odo.push(adtb);
                  }
                }
  
                odon[idx] = this.sortingDataOdon(odo);
              });
              return { ...d, odontogram: odon }
            });
            this.simbolOdontogram = {
              data: dataSimbol,
              page: data.current_page,
              limit: data.per_page,
              last_page: data.last_page,
              col_left:  this.setCol(data.current_page, 'left'),
              col_right: this.setCol(data.current_page, 'right'),
            }
          }
        } catch (err) {}
      },
      sortingDataOdon(data) {
        let img = data.filter(d => d.position == 'image');
        let other = data.filter(d => d.position != 'image');
        return [...img, ...other];
      },
      classSimbolOdon(code, pos, def = 'O') {
        let fill = 'fill-transparent';
        let allCar = false;
        if (['car','fmc','poc'].includes(code) && pos == 'all') allCar = true;
        if (def.includes(pos) && !allCar) {
          switch(code) {
            case 'amf - rct':
              fill = 'fill-amf';
              break;
            case 'amf':
              fill = 'fill-amf';
              break;
            case 'car':
              fill += ' fill-car';
              break;
            case 'fmc':
              fill += ' fill-fmc';
              break;
            case 'poc':
              fill += ' fill-poc';
              break;
          }
        } else {
          switch(code) {
            case 'cof':
              fill = 'fill-white';
              break;
            case 'fis':
              fill = 'fill-white';
              break;
            case 'gif':
              fill = 'fill-white';
              break;
            case 'cof - rct':
              fill = 'fill-white';
              break;
          }
        }
        return `${code} ${fill}`;
      },
      pointsSimbolOdon(num, pos) {
        if (this.posOdon.front.includes(num)) return this.polygon.empat[pos];
        return this.polygon.lima[pos];
      },
      additionalSimbolOdon(polygon, pos, code = '', isModal = false) {
        let stroke = '#515151';
        let stroke_width = '0.2';
        let opacity = 1;
        let cl = 'fill-transparent';
        let points = null;
        let top = this.getPositionOdon('top');
        let bottom = this.getPositionOdon('bottom');
  
        if (['nvt','rct'].includes(code) && !isModal) {
          if (top.includes(polygon)) points = this.polygon.angle_down;
          else if (bottom.includes(polygon)) points = this.polygon.angle_up;
        } else {
          points = this.polygon.angle_down;
        }
  
        if (['nvt','rct','fmc-all','poc-all','pob','meb','pon','arrow-left','arrow-right','border','abu'].includes(code)) {
          if (code == 'rct') cl = 'fill-black';
          else if (['arrow-left','arrow-right'].includes(code)) {
            if (top.includes(polygon)) points = code == 'arrow-left' ? this.polygon.arrow_up_left : this.polygon.arrow_up_right;
            else if (bottom.includes(polygon)) points = code == 'arrow-left' ? this.polygon.arrow_down_left : this.polygon.arrow_down_right;
  
            stroke = '#000000';
            stroke_width = 2;
          }
          else if (['fmc-all','poc-all','pob','meb','pon','border','abu'].includes(code)) {
            stroke = '#000000';
            stroke_width = 2;
            points = this.polygon.fmc;
          }
  
          return {
            no: polygon,
            position: pos,
            class: cl,
            defaultClass: cl,
            points: points,
            stroke: stroke,
            stroke_width: stroke_width,
            opacity: opacity,
          }
        } else if (['non','une','pre','ano','rrx','car-all','mis','ipx','prd','fld','prd/fld','txt-prd','txt-fld','txt-prd/fld','cfr'].includes(code)) {
          let n = code;
          points = null;
          if (['car-all','rrx'].includes(code)) points = this.polygon.txt_v;
          else if (['mis','prd','fld','prd/fld'].includes(code)) points = this.polygon.txt_x;
          else if (code == 'txt-prd') n = 'prd';
          else if (code == 'txt-fld') n = 'fld';
          else if (code == 'txt-prd/fld') n = 'prd/fld';
          
          return {
            no: n,
            position: points ? code + '-all' : 'text',
            class: code,
            defaultClass: code,
            stroke: stroke,
            stroke_width: stroke_width,
            opacity: opacity,
            points: points,
          };
        } else if (['arsir-cof','arsir-poc','arsir-pob','arsir-fis','arsir-gif','arsir-l','arsir-r','arsir-t','arsir-b'].includes(code)) {
          return {
            no: code,
            position: 'image',
            class: code,
            defaultClass: code,
            stroke: stroke,
            stroke_width: stroke_width,
            opacity: opacity,
          }
        }
      },
      async pagesimbol(type) {
        if (type == 'next') this.simbolOdontogram.page += 1;
        else if (type == 'previous') this.simbolOdontogram.page -= 1;
        await this.fetchSimbolOdontogram();
      },
      setCol(page, position) {
        if ([1,2].includes(page)) {
          if (position == 'left') return 3;
          else if (position == 'right') return 9;
        } else if ([4].includes(page)) {
          if (position == 'left') return 5;
          else if (position == 'right') return 7;
        } else {
          if (position == 'left') return 2;
          else if (position == 'right') return 10;
        }
      },
      setX(code) {
        switch(code) {
          case 'prd/fld':
            return 0;
          default:
            return 4;
        }
      },
      setY(num, code, isModal = false) {
        if (isModal) {
          if (['ipx','prd','fld','prd/fld'].includes(code)) return 26;
          return -1
        }
        if (this.getPositionOdon('top').includes(num)) {
          if (['prd','fld','ipx'].includes(code)) return 25;
          return -10;
        } else if (this.getPositionOdon('bottom').includes(num)) {
          if (['prd','fld','ipx'].includes(code)) return -2;
          return 33;
        }
        return -1;
      },
      checkText(code) {
        if (['cfr','rrx','car-all','mis','prd','fld','prd/fld'].includes(code)) return true;
        return false;
      },
      getSimbolTmpInputData(tmp) {
        let simbols = [];
        if (tmp.keadaan_gigi.length > 0) tmp.keadaan_gigi.forEach(kg => { simbols.push(kg.value) });
        if (tmp.bahan_restorasi.length > 0) tmp.bahan_restorasi.forEach(br => { simbols.push(br.value) });
        if (tmp.restorasi.length > 0) tmp.restorasi.forEach(r => { simbols.push(r.value) });
        if (tmp.protesa.length > 0) tmp.protesa.forEach(p => { simbols.push(p.value) });
        return simbols;
      },
      simbolOdontogramModal(idx) {
        let tmp = this.tmpInputData[idx];
        let position = tmp.permukaan_gigi && tmp.permukaan_gigi.value;
        let simbols = this.getSimbolTmpInputData(tmp);
        
        this.tmpInputData[idx].odontogram = this.generateSimbolOdontogram(tmp.odontogram, position, tmp.no, simbols, true);
      },
      async simbolOdontogramLayout(data, no_gigi = 0) {
        let arrowMis = [], arrowPon = [];
        let noGigi = [...new Set(data.map(d => d.no_gigi))];
  
        if (no_gigi) this.odontogram[no_gigi] = this.defaultOdontogram(no_gigi);
        if (noGigi.length > 0) {
          noGigi.forEach(ng => {
            let odon = [], positions = [];
            data.filter(d => d.no_gigi == ng).forEach(v => {
              let tmp = this.findOdontogram(v.no_gigi);
              let position = v.permukaan_gigi;
              let simbols = this.setKondisi(v).split(' - ');
              if (position == 'all') {
                if (simbols.includes('mis')) arrowMis.push(ng);
                if (simbols.includes('pon')) arrowPon.push(ng);
              }
  
              positions.push(position);
              this.generateSimbolOdontogram(tmp, position, v.no_gigi, simbols).forEach(v => {
                odon.push(v);
              });
            });
            this.odontogram[ng] = this.odonPositionUnique(odon, positions);
          });
        }
  
        if (arrowMis.length > 0) this.setAdditionalArrow(data, arrowMis);
        else if (arrowPon.length > 0) this.setAdditionalArrow(data, arrowPon);
  
        await this.convertOdontogramToImage();
      },
      setAdditionalArrow(data, arrows) {
        arrows.forEach(m => {
          let x = null;
          Object.keys(this.numOdontogram).forEach(n => {
            if (x) return;
            if (this.numOdontogram[n].includes(m)) x = n;
          });
          let idx = this.numOdontogram[x].indexOf(m);
  
          // additional polygon arrow right
          const afterNum = this.numOdontogram[x][idx+1];
          let left = data.filter(d => this.checkKondisi(d, afterNum));
          if (left.length > 0) {
            let adtlLeft = this.additionalSimbolOdon(afterNum, 'x-arrow-left-' + afterNum, 'arrow-left', false);
            if (adtlLeft && adtlLeft != undefined) {
              let odonLeft = [];
              this.findOdontogram(afterNum).forEach(ol => odonLeft.push(ol));
              odonLeft.push(adtlLeft);
              this.odontogram[afterNum] = this.sortingDataOdon(odonLeft);
            }
          }
  
          // additional polygon arrow left
          const beforeNum = this.numOdontogram[x][idx-1];
          let right = data.filter(d => this.checkKondisi(d, beforeNum));
          if (right.length > 0) {
            let adtlRight = this.additionalSimbolOdon(beforeNum, 'x-arrow-right-' + beforeNum, 'arrow-right', false);
            if (adtlRight && adtlRight != undefined) {
              let odonRight = [];
              this.findOdontogram(beforeNum).forEach(or => odonRight.push(or));
              odonRight.push(adtlRight);
              this.odontogram[beforeNum] = this.sortingDataOdon(odonRight);
            }
          }
  
          // additional polygon border
          if (left.length > 0 || right.length > 0) {
            let odon = [];
            let adtl = this.additionalSimbolOdon(m, 'x-border-' + m, 'border', false);
            if (adtl && adtl != undefined) {
              this.findOdontogram(m).forEach(om => odon.push(om));
              odon.push(adtl);
            }
  
            // additional image
            let c = false;
            data.filter(d => d.no_gigi == afterNum)
            .forEach(v => {
              if (c) return;
              if (this.setKondisi(v).split(' - ').includes('pob')) c = true;
            });
  
            if (!c) {
              data.filter(d => d.no_gigi == beforeNum)
              .forEach(v => {
                if (c) return;
                if (this.setKondisi(v).split(' - ').includes('pob')) c = true;
              });
            }
  
            if (c) {
              let adtlImg = this.additionalSimbolOdon(m, 'x-arsir-pob', 'arsir-pob', false);
              if (adtlImg && adtlImg != undefined) odon.push(adtlImg);
            }
  
            this.odontogram[m] = this.sortingDataOdon(odon);
          }
        });
      },
      checkKondisi(data, no_gigi) {
        let simbols = this.setKondisi(data).split(' - '), result = false;
        if (data.no_gigi == no_gigi && data.permukaan_gigi == 'all') {
          for (let i in simbols) {
            if (['meb','pon','abu','pob'].includes(simbols[i])) {
              result = true;
              break;
            }
          }
        }
        return result;
      },
      odonPositionUnique(arr, positions) {
        if (arr.length === 0) return arr;
        let arsir = arr.find(a => a.class.includes('arsir'));
        let arrOdon = arr.filter(d => this.positions.includes(d.position))
          .filter(v => (positions.includes(v.position) && v.class != 'fill-transparent') || !positions.includes(v.position))
          .map(a => {
            if (arsir && positions.includes(a.position)) return { ...a, class: 'fill-transparent' };
            return a;
          });
        let arrOdonFilled = arrOdon.filter(a => a.defaultClass != 'fill-transparent' && a.defaultClass != 'fill-white')
          .map(v => ({...v, class: v.defaultClass}));
  
        let flags = [], output = [],
          newArrOdon = [...arrOdonFilled, ...arrOdon.filter(a => !arrOdonFilled.map(aof => aof.position).includes(a.position))];
        for (let x in newArrOdon) {
          if (flags[newArrOdon[x].position]) continue;
          flags[newArrOdon[x].position] = true;
  
          if (newArrOdon.find(v => v.position == newArrOdon[x].position && v.class == 'fill-white')) output.push({...newArrOdon[x], class: 'fill-white'});
          else output.push(newArrOdon[x]);
        }
        return this.sortingDataOdon([...output, ...arr.filter(d => !this.positions.includes(d.position))]);
      },
      generateSimbolOdontogram(odontogram, position, polygon, simbols, isModal = false) {
        let odo = [];
        // start main polygon
        odontogram.filter(o => this.positions.includes(o.position))
        .forEach(item => {
          if (position == 'all') {
            let cls = simbols.map(s => this.classSimbolOdon(s, 'all', position));
            cls = [...new Set(cls.join(' ').split(' '))].filter(c => c != '').join(' ');
            odo.push({
              ...item,
              class: cls ? cls : 'fill-transparent',
              defaultClass: cls ? cls : 'fill-transparent',
            });
          } else {
            if (item.position == position) {
              let cls = simbols.map(s => this.classSimbolOdon(s, item.position, position));
              cls = [...new Set(cls.join(' ').split(' '))].filter(c => c != '').join(' ');
              odo.push({
                ...item,
                class: cls ? cls : 'fill-transparent',
                defaultClass: cls ? cls : 'fill-transparent',
              });
            } else {
              let cl = 'fill-transparent';
              if (simbols.includes('cof') || simbols.includes('poc') || simbols.includes('fis') || simbols.includes('gif')) cl = 'fill-white';
              odo.push({ ...item, class: cl, defaultClass: cl });
            }
          }
        });
        // end main polygon
  
        // start additional polygon
        if (position == 'all') {
          if (simbols.includes('car')) simbols.push('car-all');
          else simbols = simbols.filter(s => !['car-all'].includes(s));
  
          if (simbols.includes('fmc')) simbols.push('fmc-all');
          else simbols = simbols.filter(s => !['fmc-all'].includes(s));
  
          if (simbols.includes('poc')) simbols.push('poc-all');
          else simbols = simbols.filter(s => !['poc-all'].includes(s));
        }
        simbols.forEach(s => {
          ['cof','poc','pob','fis','gif'].forEach(arsir => {
            if (s.includes(arsir)) {
              let adtlArsir = this.additionalSimbolOdon(polygon, 'x-' + arsir, 'arsir-' + arsir);
              if (adtlArsir && adtlArsir != undefined) odo.push(adtlArsir);
            }
          });
          let adtl = this.additionalSimbolOdon(polygon, 'x-' + s, s, isModal);
          if (adtl && adtl != undefined) odo.push(adtl);
  
          if (['pob','prd','fld'].includes(s)) {
            let adtlTxt = this.additionalSimbolOdon(polygon, 'txt-' + s, 'txt-' + s);
            if (adtlTxt && adtlTxt != undefined) odo.push(adtlTxt);
          }
        });
        return this.sortingDataOdon(odo);
      },
    },
    async mounted() {
      await this.resizeWidth(window.innerWidth, this.collapsed);

      this.ctx = this.canvas.getContext('2d');
      this.ctx.strokeStyle = '#222222';
      this.ctx.lineWidth = this.penWidth;
      this.ctx.lineJoin = 'round';
      this.ctx.lineCap = 'round';
  
      // append data canvas to vuex global state
      this.updateCanvas({ key: 'ODONTOGRAM', value: this.canvas });
      this.updatePostData({ key: 'odontogram_is_draw', value: false });
  
      // Get a regular interval for drawing to the screen
      window.requestAnimFrame = (function(callback) {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimaitonFrame ||
          function(callback) {
            window.setTimeout(callback, 1000 / 60);
          }
        );
      })();
  
      // Prevent scrolling when touching the canvas
      document.body.addEventListener(
        'touchstart',
        function(e) {
          if (e.target == document.getElementById('odontogram-canvas')) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchend',
        function(e) {
          if (e.target == document.getElementById('odontogram-canvas')) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchmove',
        function(e) {
          if (e.target == document.getElementById('odontogram-canvas')) {
            e.preventDefault();
          }
        },
        false
      );
  
      // default odontogram
      this.setDataOdontogram();

      this.ediRekamMedis = localStorage.getItem('edit_rekam_medis');
      if (this.ediRekamMedis != null) this.setOdontogramData(JSON.parse(this.ediRekamMedis));
  
      this.tmpInputData = this.defaultTmpInputData();
      this.option_permukaan_gigi = this.defaultPermukaanGigi();
  
      await this.asyncFindICDX();
      await this.fetchSimbolOdontogram();
      await this.fetchOdontogramTable();
    },
  };
</script>
  
<style lang="scss">
  .form-odontogram .quill-editor .ql-toolbar {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  .form-odontogram .quill-editor .ql-container {
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .form-odontogram .quill-editor .ql-container {
    color: #505050;
    font-size: 14px;
  }
  .custom_select .vs__dropdown-toggle .vs__selected-options .vs__search::placeholder {
    color:#cfcfcf !important;
    font-size: 14px !important;
  }
  .__select-photo .vs__dropdown-menu {
    position: relative;
  }
  .tooltip .tooltip-inner {
    background: #fff;
    color: #000;
    border-radius: 5px;
    padding: 5px 10px 4px;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
  }
  .tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #fff;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
    z-index: 1;
  }
  .color-info {
    color: #3772d7;
  }
  .head-custom-odon {
    padding: 1.25rem 0.75rem !important;
    vertical-align: middle !important;
    background-color: #fff !important;
    border-bottom: 2px solid #eee !important;
  }
  #modal-odontogram___BV_modal_body_ {
    padding-left: 0px;
    padding-right: 0px;
  }
  .page-info {
    color: #3772d7;
    border-color: #eeeff8;
  }
  .page-info:hover {
    color: #3772d7;
    border-color: #eeeff8;
  }
  .custom_multiselect .multiselect__tag {
    background: #11c5db !important;
  }
  .custom_multiselect .multiselect__option--highlight {
    background: #11c5db !important;
  }
  .custom_multiselect .multiselect__option--highlight::after {
    background: #11c5db !important;
  }
  .custom_multiselect .multiselect__option--selected.multiselect__option--highlight {
    background: #3772d7 !important;
  }
  .custom_multiselect .multiselect__option--selected.multiselect__option--highlight::after {
    background: #3772d7 !important;
  }
  .custom_border {
    border: 2px solid #eee;
    border-radius: 5px;
  }
  .custom_border td, .custom_border th {
    vertical-align: top;
  }
  .total .form-control[readonly] {
    opacity: 1;
    background-color: #EEEFF8;
    pointer-events: none;
  }
  .table-kriteria-border {
    border-collapse: separate;
    border: 1px solid #d1d2db;
    border-radius: 5px;
  }
  .table-kriteria-border tr td {
    padding: 0.4rem 1rem;
  }
</style>
  
<style scoped>
  canvas {
    border-radius: 10px;
    cursor: crosshair;
  }
  .odontogram {
    border: 1px solid #e8e8e8;
    border-radius: 10px;
  }
  #odontogram-canvas {
    touch-action: none;
  }
  .hr-blue {
    border: 0.15rem solid #11c5db;
  }
  polygon {
    cursor: pointer;
  }
  text {
    cursor: pointer;
  }
  .fs-7 {
    font-size: 0.75rem;
  }
  .icon-minus {
    padding: 0.1rem 0.35rem;
    border-radius: 100%;
  }
  .pl-3-2 {
    padding-left: 3.2rem;
  }
  .pr-5-0 {
    padding-right: 5rem;
  }
  .hr-odo {
    border: 1px solid #cccccc;
  }
  .invalid-feedback {
    min-height: 18px;
    display: block;
  }
  .fs-2-5 {
    font-size: 0.25rem;
  }
  .fs-3 {
    font-size: 0.3rem;
  }
  .fs-3-5 {
    font-size: 0.35rem;
  }
  .fs-4 {
    font-size: 0.4rem;
  }
  .fs-9 {
    font-size: 0.9rem;
  }
  .fs-1-25 {
    font-size: 1.25rem;
  }
  .fw-5 {
    font-weight: 500;
  }
  
  .fw-6 {
    font-weight: 600;
  }
  .media-desc {
    margin-left: -15px;
    margin-top: 1.3rem;
  }
  .mb-3-25 {
    margin-bottom: 3.25rem;
  }
  .mb-4-0 {
    margin-bottom: 4rem;
  }
  .fill-transparent {
    fill: transparent;
  }
  .fill-white {
    fill: #ffffff;
  }
  .fill-black {
    fill: #000000;
  }
  .fill-green {
    fill: #058940;
  }
  .fill-ccc {
    fill: #cccccc;
  }
  .fill-51 {
    fill: #515151;
  }
  .fill-90 {
    fill: #909399;
  }
  .fill-amf {
    fill: #000000;
  }
  .fill-fis {
    fill: #e39ba0;
  }
  .fill-car {
    stroke: #000000;
    stroke-width: 1;
  }
  .scale-0-5 {
    transform: scale(0.5);
    cursor: default;
  }
  .fill-gif {
    fill: #e39ba0;
  }
  .fill-fmc {
    stroke: #000000;
    stroke-width: 1;
  }
  .fill-poc {
    stroke: #000000;
    stroke-width: 1;
  }
</style>
